/**
 * ----------------------------------------------------------------------------------------------------
 * BASE
 * ----------------------------------------------------------------------------------------------------
 */

/**
 * GLOBAL VARIABLES
 */

var position = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop,
    lastScrollDirection = '',
    winHeightPadded = window.innerHeight * 1.1,
    hasFaded = 0;

/**
 * HELPER FUNCTIONS
 */

// Animates a numerical value
function animateValue(element, start, end, duration) {
  let startTimestamp = null,
      domain = window.location.hostname;
  
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1),
          newValue = Math.floor(progress * (end - start) + start);
    var newValueFormatted = newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    
    if (domain.indexOf('us.') != -1 || domain.indexOf('uk.') != -1 || domain.indexOf('eu.') != -1) newValueFormatted = newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");    
    if (domain.indexOf('de.') != -1) newValueFormatted = newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");    
    element.textContent = newValueFormatted;    
    if (progress < 1) window.requestAnimationFrame(step);
  };
  
  window.requestAnimationFrame(step);
}

// Triggers a call to a function after a certain delay
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Returns the fetch config for cart api
function fetchConfig(method = 'POST', type = 'json', accept = 'json') {
  return {
    method: method,
    headers: { 'Content-Type': `application/${type}`, Accept: `application/${accept}` },
  };
}

// Converts a string into a price
(Shopify.utils = {
  defaultTo: function (t, e) {
      return null == t || t !== t ? e : t;
  },
}),
(Shopify.formatMoney = function (t, e) {
  function i(t, e, i, o) {
      if (((e = Shopify.utils.defaultTo(e, 2)), (i = Shopify.utils.defaultTo(i, ",")), (o = Shopify.utils.defaultTo(o, ".")), isNaN(t) || null == t)) return 0;
      t = (t / 100).toFixed(e);
      var s = t.split("."),
          n = s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
          r = s[1] ? o + s[1] : "";
      return n + r;
  }
  var o = "${{amount}}";
  "string" == typeof t && (t = t.replace(".", ""));
  var s = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      r = e || o;
  switch (r.match(n)[1]) {
      case "amount":
          s = i(t, 2);
          break;
      case "amount_no_decimals":
          s = i(t, 0);
          break;
      case "amount_with_comma_separator":
          s = i(t, 2, ".", ",");
          break;
      case "amount_no_decimals_with_comma_separator":
          s = i(t, 0, ".", ",");
          break;
      case "amount_no_decimals_with_space_separator":
          s = i(t, 0, " ");
  }
  return r.replace(n, s);
});

// Gets an element offset
function getOffset(element) {
  const box = element.getBoundingClientRect();

  return {
    top: box.top + window.pageYOffset - document.documentElement.clientTop,
    left: box.left + window.pageXOffset - document.documentElement.clientLeft
  }
}

// Gets a section inner HTML
function getSectionInnerHTML(html, selector = '.shopify-section') {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

// Gets an element siblings
function getSiblings(element) {
  var siblings = [].filter.call(element.parentNode.children, function(child) {
    return child !== element;
  });

  return siblings;
}

// Returns "true" if the slider is initialized with swiper
function isSliderInitialized(element) {
  var carousel = element.closest('.carousel');
  
  return carousel !== null && carousel.classList.contains('swiper-initialized') ? true : false;
}

// Returns "true" if the current page is the home page
function isHomePage() {
  return window.location.pathname.split('/').length == 2 ? true : false;
}

// Returns "true" if the element is inside a modal
function isInModal(element) {
  return element.closest('.modal') !== null || element.closest('body') === null ? true : false;
}

// Returns "true" if the element is inside a modal
function isInProductCard(element) {
  return element.closest('.item-product') !== null ? true : false;
}

// Checks if an element is numeric
function isNumeric(element) {
  return typeof element === 'number';
}

// Returns "true" if the current page is the "pageHandle" page
function isPage(pageHandle) {
  return window.location.href.indexOf(pageHandle) != -1 ? true : false;
}

// Creates the event listeners needed after fetch
function setupInlineScripts(container) {
  var inlineScripts = container.querySelectorAll('script');

  inlineScripts.forEach((element) => {
    const script = document.createElement('script');
    var scriptSrc = element.getAttribute('src'),
        scriptType = element.getAttribute('type'),
        scriptContent = element.innerHTML,
        parent = element.parentNode;

    element.remove();
    if (scriptType !== null) script.type = scriptType;
    
    if (scriptSrc !== null) {      
      script.src = scriptSrc;
      script.defer = true;
      parent.prepend(script);
    } else {
      script.defer = false;
      script.innerHTML = scriptContent;
      parent.appendChild(script);
    }
  });
}

// Allows consecutive calls to be avoided by introducing a time delay
function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

// Shows or hides an element
function toggle(element, displayVisible) {
  element.ownerDocument.defaultView.getComputedStyle(element, null).display === 'none' ? element.style.display = displayVisible : element.style.display = 'none';
}

/**
 * HELPER FUNCTIONS - BANDS
 */

// Hides a banner
function hideBand(section) { 
  if (section !== null) {
    section.style.transition = 'opacity 0.4s';
    section.style.opacity = '0';
    section.parentNode.removeChild(section);
    
    if (window.innerWidth < 650 && section.classList.contains('shopify-section__cookies-bar')) {
      var gorgiasChatContainer = document.getElementById('gorgias-chat-container');
      
      if (gorgiasChatContainer !== null) gorgiasChatContainer.getElementById('chat-button').style.marginBottom = "0px";
    }
  }
}

// Displays a banner
function showBand(section) {
  if (section !== null && section.children.length) {
    section.style.transition = 'opacity 0.4s';
    section.style.opacity = '1';      
    section.style.display = 'block';
    
    if (window.innerWidth < 650 && section.classList.contains('shopify-section__cookies-bar')) {
      var gorgiasChatContainer = document.getElementById('gorgias-chat-container');
      
      if (gorgiasChatContainer !== null) gorgiasChatContainer.getElementById('chat-button').style.marginBottom = "40px";
    }
  }
}

/**
 * HELPER FUNCTIONS - QUANTITIES
 */

// Adds 1 or 'step' to the quantity of the item
function addQuantity() {
  var target = event.currentTarget,
      quantity = target.closest('.product__quantity'),
      quantityWrapper = quantity.querySelector('.product__quantity-wrapper'),
      quantityMin = parseInt(quantityWrapper.dataset.min),
      quantityMax = parseInt(quantityWrapper.dataset.max),
      quantityStep = parseInt(quantityWrapper.dataset.step),
      quantitySubButton = quantityWrapper.querySelector('.button--quantity-sub'),
      quantityAddButton = quantityWrapper.querySelector('.button--quantity-add'),
      quantityItem = target.parentNode.querySelector('.product__quantity-value'),
      quantityValue = parseInt(quantityItem.textContent),
      newValue = quantityValue + quantityStep;

  if (quantityMax == 0) quantityItem.textContent = newValue;

  if (quantityMax > 0) {
    if (quantityMax > newValue) {
      quantityItem.textContent = newValue;
      quantityAddButton.removeAttribute('disabled');
    } else {
      quantityItem.textContent = quantityMax;
      quantityAddButton.setAttribute('disabled', 'disabled');
    }
  }
  
  if (newValue > quantityMin) {
    quantitySubButton.removeAttribute('disabled');
    var itemProduct = target.closest('.item-product');
    if (itemProduct !== null) itemProduct.classList.add('selected');
  }
}

// Remove 1 or 'step' from the quantity of the item
function subQuantity() { 
  var target = event.currentTarget,
      quantity = target.closest('.product__quantity'),
      quantityWrapper = quantity.querySelector('.product__quantity-wrapper'),
      quantityMin = parseInt(quantityWrapper.dataset.min),
      quantityStep = parseInt(quantityWrapper.dataset.step),
      quantitySubButton = quantityWrapper.querySelector('.button--quantity-sub'),
      quantityItem = target.parentNode.querySelector('.product__quantity-value'),
      quantityValue = parseInt(quantityItem.textContent),
      newValue = quantityValue - quantityStep;
  
  if (newValue >= quantityMin) quantityItem.textContent = newValue;
  if (newValue <= quantityMin) {
    quantitySubButton.setAttribute('disabled', 'disabled');
    var itemProduct = target.closest('.item-product');
    if (itemProduct !== null) itemProduct.classList.remove('selected');
  }
}

/**
 * HELPER FUNCTIONS - SCROLL
 */

// Returns the vertical scroll direction
function getVerticalScrollDirection() {
  var scrolled = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop,
      delta = scrolled - position,
      verticalScrollDirection = '';
  
  if (scrolled >= 20 && delta > 20) {
    verticalScrollDirection = 'down';
  } else if (scrolled < 20 || delta < -20) {
    verticalScrollDirection = 'up';
  }
  
  return verticalScrollDirection;
}

// Checks if an element is in the viewport
function isInViewport(element) {
  if (element !== null) {
    var elementTop = getOffset(element).top,
        elementBottom = elementTop + element.clientHeight,
        viewportTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop,
        viewportBottom = viewportTop + winHeightPadded;
    
    return elementBottom > viewportTop && elementTop < viewportBottom;
  } else {
    return false
  }
}

// Scrolls to the element passed in parameter
function scrollToElement(element) {
  element.scrollIntoView({ behavior: "smooth" });
}

// Scrolls to the top of the page
function scrollToTop() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

// Scrolls to the top of the popup
function scrollToTopModal() {
  var target = event.currentTarget,
      modal = target.closest('.modal');
  
  scrollToElement(modal);
}

/**
 * -------------------------------
 * GENERAL
 * -------------------------------
 */

/**
 * ON LOAD
 */

// On page load
window.addEventListener('DOMContentLoaded', domContentloadedHandler);

// On dom content loaded
function domContentloadedHandler() {
  // As a priority
  displayAnnouncementBars();
  startCountdowns();
  handleStickyHeader();
  handleLandingPage();
  handleUrlParameters();

  // Then
  startCarousels(false);
  startLoopsTexts();
  startDynamicNumbers();
  startProductCompareBars('all', true);
  startAnimations();
  checkCartContent();
  checkFooter();
  openSidebars();
  openModals('load');
  saveViewedProduct();

  // Noly
  changeActiveProductTypeInCollection();
}

// Displays the announcement bars
function displayAnnouncementBars() {    
  document.querySelectorAll('.carousel--announceme').forEach((element) => {
    checksDisplayBlocks(element);
  });
}

// Checks the source of the announcement block
function checksDisplayBlocks(carousel) {
  var announcementBar = carousel.closest('.announcement-bar'),
      announcementBarSource = announcementBar.dataset.source,
      announcementBarUtmSource = announcementBar.dataset.utmSource,
      windowSearch = window.location.search,
      windowSearchAnnouncementBarsFromSources = document.querySelectorAll('.announcement-bar[data-source="' + windowSearch + '"]'),
      windowSearchHasBlockFromSource = false,
      windowSearchHasBlockFromUtmSource = false,
      removeAnnouncement = false;
  
  // If one of the blocks has as source the utm of the url
  if (windowSearchAnnouncementBarsFromSources.length > 0) windowSearchHasBlockFromSource = true;
  
  // If one of the blocks has as utm_source the utm of the url
  getSiblings(announcementBar).forEach((element) => {
    var siblingUtmSource = element.dataset.utmSource;
    
    if (siblingUtmSource != "" && windowSearch.indexOf(siblingUtmSource) != -1) {
      windowSearchHasBlockFromUtmSource = true;
    }
  });
  
  // If the utm of the url is empty AND the source or utm_source of the block is not empty
  if (windowSearch == "" && (announcementBarSource != "" || announcementBarUtmSource != "")) removeAnnouncement = true;
  
  // If the utm of the url is not empty AND the source AND the utm_source of the block are empty
  if (windowSearch != "" && announcementBarSource == "" && announcementBarUtmSource == "") removeAnnouncement = true;
  
  // If the utm of the url is not empty AND the source of the block is not empty AND the utm and the source are different
  if (windowSearch != "" && announcementBarSource != "" && windowSearch != announcementBarSource) removeAnnouncement = true;
  
  // If the utm of the url is not empty AND the utm_source of the block is not empty AND the utm does not contain the utm_source
  if (windowSearch != "" && announcementBarUtmSource != "" && windowSearch.indexOf(announcementBarUtmSource) == -1) removeAnnouncement = true;
  
  // If the utm of the url is not empty AND the source of the block is empty AND the utm_source of the block is not empty AND the utm of the url has an associated block
  if (windowSearch != "" && announcementBarSource == "" && announcementBarUtmSource != "" && windowSearchHasBlockFromSource) removeAnnouncement = true;
  
  // If the utm of the url is not empty AND the source AND the source utm_ of the block are empty AND the utm of the url has no associated block
  if (windowSearch != "" && announcementBarSource == "" && announcementBarUtmSource == "" && !windowSearchHasBlockFromSource && !windowSearchHasBlockFromUtmSource) removeAnnouncement = false;
  
  removeAnnouncement ? announcementBar.remove() : checkAnnouncementBarDisplayMessages(carousel);
}

// Checks the timing of sub-messages in the announcement carousel
function checkAnnouncementBarDisplayMessages(carousel) {
  var announcementBar = carousel.closest('.announcement-bar');
  
  if (carousel.classList.contains('hidden')) {
    var cells = carousel.querySelector('.carousel-cell'),
        now = new Date(),
        y = now.getFullYear(),
        m = now.getMonth(),
        day = now.getDate(),
        d = now.getDay(),
        dText = d.toString(),      
        h = now.getHours();
    
    cells.forEach((cell) => {
      var cellSiblings = getSiblings(cell),
          message = cell.querySelector('.item-announcement'),
          subMessages = message.querySelector('.announcement__sub-message');
      
      subMessages.forEach((subMessage) => {
        var subMessageSiblings = getSiblings(subMessage),
            temporality = subMessage.dataset.temporality,
            temporalitySplit = temporality.split('/'),
            days = temporalitySplit[0],
            hours = temporalitySplit[1],
            hoursSplit = hours.split('-'),
            firstHour = parseInt(hoursSplit[0]),
            lastHour = parseInt(hoursSplit[1]),
            expirationDate = subMessage.dataset.expirationDate,
            expirationDateSplit = expirationDate.split('/'),
            yExp = parseInt(expirationDateSplit[2]),
            mExp = parseInt(expirationDateSplit[1]) - 1,
            dExp = parseInt(expirationDateSplit[0]),
            displaySubMessage = true;
        
        // Checks if the day and time match
        if (days != 'all') {
          if (days.indexOf(dText) == -1) {
            displaySubMessage = false;
          } else {
            if (hours != 'all') {
              if (h < firstHour || h >= lastHour) {
                displaySubMessage = false;
              }
            }
          }
        } else {
          if (hours != 'all') {
            if (h < firstHour || h >= lastHour) {
              displaySubMessage = false;
            }
          }
        }
        
        // Checks if the expiry date has not been reached
        if (expirationDate != 'none' && expirationDate != '') {
          if (y >= yExp && m >= mExp && day >= dExp) {
            displaySubMessage = false;
          }
        }  
        
        // Checks which item to delete or display
        if (!displaySubMessage) {
          if (subMessageSiblings === null) {
            if (cellSiblings === null) {
              announcementBar.remove();
            } else {
              cell.remove();
              
              // If we delete a message, we have to adjust the number of elements to display for the carousel and for each device
              var nbCells = cellSiblings.length,
                  SlidesPerViewMobile = carousel.dataset.SlidesPerViewMobile,
                  SlidesPerViewTablet = carousel.dataset.SlidesPerViewTablet,
                  SlidesPerViewDesktop = carousel.dataset.SlidesPerViewDesktop;              
              
              if (nbCells < SlidesPerViewMobile) carousel.setAttribute('data-slides-per-view-mobile', SlidesPerViewMobile - 1);              
              if (nbCells < SlidesPerViewTablet) carousel.setAttribute('data-slides-per-view-tablet', SlidesPerViewTablet - 1);               
              if (nbCells < SlidesPerViewDesktop) carousel.setAttribute('data-slides-per-view-desktop', SlidesPerViewDesktop - 1);
            }
          } else {
              subMessage.remove();
          }
        } else {
          subMessage.classList.remove('hidden');
          carousel.classList.remove('hidden');
          announcementBar.classList.remove('loading');
        }
      });
    });
  } else {
    announcementBar.classList.remove('loading');
  }
}

// Starts the different carousels
function startCarousels(modal) {
  var carousels = document.querySelectorAll('.swiper:not(.grid)');

  carousels.forEach((carousel) => {
    var carouselWrapper = carousel.querySelector('.swiper-wrapper'),
        carouselEnabledMobile = carouselWrapper.dataset.enabledMobile,
        carouselEnabledTablet = carouselWrapper.dataset.enabledTablet,
        carouselEnabledDesktop = carouselWrapper.dataset.enabledDesktop;

    if (window.innerWidth < 650 && carouselEnabledMobile == 'true') {
      startCarousel(carousel, carouselWrapper, modal);
    } else if (window.innerWidth >= 650 && window.innerWidth <= 1024 && carouselEnabledTablet == 'true') {
      startCarousel(carousel, carouselWrapper, modal);
    } else if (window.innerWidth > 1024 && carouselEnabledDesktop == 'true') {
      startCarousel(carousel, carouselWrapper, modal);
    }
  });

  setupEventListenersForCarousels();
}

// Starts a carousel
function startCarousel(carousel, carouselWrapper, modal) { 
  var container = carousel.closest('.shopify-block'),
      nbCells = carousel.querySelectorAll('.carousel-cell').length,
      paginationDynamicBullets = false,
      paginationDynamicLimit = 10;

  if (container === null) container = carousel.querySelector('.section');
  var containerId = container.dataset.id;

  if (nbCells > paginationDynamicLimit) paginationDynamicBullets = true;
  
  const swiper = new Swiper(carousel, {
    a11y: true,
    allowSlideNext: JSON.parse(carouselWrapper.dataset.allowSlideNext),
    allowSlidePrev: JSON.parse(carouselWrapper.dataset.allowSlidePrev),
    allowTouchMove: JSON.parse(carouselWrapper.dataset.allowTouchMove),
    autoHeight: JSON.parse(carouselWrapper.dataset.autoHeight),
    autoplay: {
      enabled: JSON.parse(carouselWrapper.dataset.autoplay),
      delay: parseInt(carouselWrapper.dataset.autoplayDelayMobile),
    },
    centeredSlides: JSON.parse(carouselWrapper.dataset.centeredSlidesMobile),
    cssMode: JSON.parse(carouselWrapper.dataset.cssMode),
    cardsEffect: {
      slideShadows: false,
    },
    coverflowEffect: {
      slideShadows: false,
    },
    cubeEffect: {
      shadow: false,
      slideShadows: false,
    },
    creativeEffect: {
      prev: {
        translate: [0, 0, -400],
      },
      next: {
        translate: ['100%', 0, 0],
      },
    },
    direction: carouselWrapper.dataset.direction,
    edgeSwipeThreshold: parseInt(carouselWrapper.dataset.edgeSwipeThreshold),
    effect: carouselWrapper.dataset.effect,
    enabled: JSON.parse(carouselWrapper.dataset.enabledMobile),
    fadeEffect: {
      crossFade: true
    },
    flipEffect: {
      slideShadows: false,
    },
    freeMode: {
      enabled: JSON.parse(carouselWrapper.dataset.freeMode),
    },
    grabCursor: true,
    grid: {
      fill: carouselWrapper.dataset.gridFill,
      rows: parseInt(carouselWrapper.dataset.gridRows),
    },
    initialSlide: parseInt(carouselWrapper.dataset.initialSlideMobile),
    loop: JSON.parse(carouselWrapper.dataset.loop),
    loopAddBlankSlides: false,
    loopAdditionalSlides: 10,
    mousewheel: JSON.parse(carouselWrapper.dataset.mousewheel),
    navigation: {
      enabled: JSON.parse(carouselWrapper.dataset.navigationMobile),
      nextEl: '.swiper-button-next' + '#swiper-button-next--' + containerId,
      prevEl: '.swiper-button-prev' + '#swiper-button-prev--' + containerId,
    },
    pagination: {
      clickable: true,
      dynamicBullets: paginationDynamicBullets,
      dynamicMainBullets: 5,
      el: '.swiper-pagination' + '#swiper-pagination--' + containerId,
      enabled: JSON.parse(carouselWrapper.dataset.paginationMobile),
      type: carouselWrapper.dataset.paginationTypeMobile,
    },
    rewind: JSON.parse(carouselWrapper.dataset.rewind),
    scrollbar: {
      draggable: true,
      el: '.swiper-scrollbar' + '#swiper-scrollbar--' + containerId,
      enabled: JSON.parse(carouselWrapper.dataset.scrollbar),
    },
    simulateTouch: JSON.parse(carouselWrapper.dataset.simulateTouch),
    slidesPerGroup: parseInt(carouselWrapper.dataset.slidesPerGroupMobile),
    slidesPerView: parseFloat(carouselWrapper.dataset.slidesPerViewMobile),
    speed: parseInt(carouselWrapper.dataset.speed),
    threshold: parseInt(carouselWrapper.dataset.threshold),
    watchOverflow: true,
    watchSlidesProgress: true,
    breakpoints: {
      // when window width is >= 650px
      650: {
        autoplay: {
          delay: parseInt(carouselWrapper.dataset.autoplayDelayTablet),
        },
        centeredSlides: JSON.parse(carouselWrapper.dataset.centeredSlidesTablet),
        enabled: JSON.parse(carouselWrapper.dataset.enabledTablet),
        initialSlide: parseInt(carouselWrapper.dataset.initialSlideTablet),
        navigation: {
          enabled: JSON.parse(carouselWrapper.dataset.navigationTablet),
        },
        pagination: {
          enabled: JSON.parse(carouselWrapper.dataset.paginationTablet),
          type: carouselWrapper.dataset.paginationTypeTablet,
        },
        slidesPerGroup: parseInt(carouselWrapper.dataset.slidesPerGroupTablet),
        slidesPerView: parseFloat(carouselWrapper.dataset.slidesPerViewTablet),
      },
      // when window width is >= 1025px
      1025: {
        autoplay: {
          delay: parseInt(carouselWrapper.dataset.autoplayDelayDesktop),
        },
        centeredSlides: JSON.parse(carouselWrapper.dataset.centeredSlidesDesktop),
        enabled: JSON.parse(carouselWrapper.dataset.enabledDesktop),
        initialSlide: parseInt(carouselWrapper.dataset.initialSlideDesktop),
        navigation: {
          enabled: JSON.parse(carouselWrapper.dataset.navigationDesktop),
        },
        pagination: {
          enabled: JSON.parse(carouselWrapper.dataset.paginationDesktop),
          type: carouselWrapper.dataset.paginationTypeDesktop,
        },
        slidesPerGroup: parseInt(carouselWrapper.dataset.slidesPerGroupDesktop),
        slidesPerView: parseFloat(carouselWrapper.dataset.slidesPerViewDesktop),
      }
    }
  });

  // If the carousel is a "product media carousel", we display the image of the selected variant if it exists
  if (carouselWrapper.classList.contains('carousel--media-prod')) {
    var urlSearch = window.location.search;

    if (urlSearch.indexOf('variant=') != -1) {
      var productVariants = ProductJSON.variants,
          currentVariantId = urlSearch.split('=').pop(),
          currentVariant = productVariants.filter((variant) => variant.id == currentVariantId);

      if (currentVariant[0].featured_media) {
        var productSlideshow = carousel,
            productSlideshowImages = productSlideshow.querySelectorAll('.carousel-cell'),
            productSlideshowImagesArray = [...productSlideshowImages],
            mediaToFind = productSlideshowImagesArray.filter((image) => image.dataset.mediaId == currentVariant[0].featured_media.id),
            thumbnailToFind = productSlideshowImagesArray.filter((image) => image.dataset.mediaId == currentVariant[0].featured_media.id && image.dataset.thumbnail == 'true');
        
        if (mediaToFind[0] && isSliderInitialized(productSlideshow)) productSlideshow.closest('.carousel').swiper.slideTo(parseInt(mediaToFind[0].getAttribute('data-slide-index')), parseInt(productSlideshow.dataset.speed), false);
        if (thumbnailToFind[0]) thumbnailToFind[0].click();
      }
    }
  }
}

// Starts the different loops texts
function startLoopsTexts() {
  document.querySelectorAll('.loop-texts-images[data-change-auto="true"]').forEach((element) => {
    var x = setInterval(() => {
      selectNexLoopItem(element);
    }, element.dataset.autoplaySpeed);
  });
}

// Animates product comparison carousels
function startProductCompareBars(carousel, animate) { 
  var compareProductsCarousels = document.querySelectorAll('.carousel--produ-comp');
  
  if (carousel != 'all') compareProductsCarousels = carousel.parentNode.querySelectorAll('.carousel--produ-comp');
  
  compareProductsCarousels.forEach((element) => {
    var carouselCells = element.querySelectorAll('.carousel-cell'),
        currentSlide = element.querySelector('.carousel-cell.swiper-slide-active');       
    
    if (carouselCells !== null && carouselCells.length == 1) {
      currentSlide = carouselCells[0]; 
    } else if (currentSlide === null) {
      currentSlide = carouselCells[0];
    }
    
    var nutritionValues = currentSlide.querySelectorAll('.compare-nutrition');

    animateProductCompareBars(nutritionValues, animate);
  });
}

// Animates the bars of a product comparison carousel
function animateProductCompareBars(nutritionValues, animate) {
  var nutritionValue = 0;
  
  nutritionValues.forEach((element) => {
    var gaugeBar = element.querySelector('.gauge-bar');

    if (animate) nutritionValue = gaugeBar.dataset.width.replace(',', '.');
    gaugeBar.style.transition = 'all 1s';
    gaugeBar.style.width = nutritionValue + '%';
  });
}

// Animates different elements of a page
function startAnimations() { 
  var animatePageTransitions = window.animations.animatePageTransitions,
      animatePageTransitionsStyle = window.animations.animatePageTransitionsStyle,
      animateSections = window.animations.animateSections,
      animateSectionsStyle = window.animations.animateSectionsStyle,
      animateSectionsBackgrounds = window.animations.animateSectionsBackgrounds,
      animateSectionsBackgroundsStyle = window.animations.animateSectionsBackgroundsStyle,
      animateImages = window.animations.animateImages,
      animateImagesStyle = window.animations.animateImagesStyle,
      animateFloatingImages = window.animations.animateFloatingImages,
      animateFloatingImagesStyle = window.animations.animateFloatingImagesStyle,
      animateButtons = window.animations.animateButtons,
      animateButtonsStyle = window.animations.animateButtonsStyle,
      animateTexts = true,
      animateTextsStyle = 'fade-in-reveal-from-bottom';
      
  var body = document.querySelector('body'),
      shopifySections = document.querySelector('.main').querySelectorAll('.shopify-section'),
      sectionsBgImages = document.querySelector('.main').querySelectorAll('.section-background-image'),
      sectionsImages = document.querySelectorAll('.block.block__image:not(.block__floating-image)'),
      sectionsFloatingImages = document.querySelectorAll('.block.block__image.block__floating-image, [data-name="icon-with-text-animate"] .block.block__icons-with-texts'),
      sectionsButtons = document.querySelectorAll('.block.block__button'),
      sectionsTexts = document.querySelectorAll('[data-name$="-animate"] .block.block__title .title-value, [data-name="icon-with-text-animate"] .block.block__icons-with-texts p');
      
  // Animates page transitions
  if (animatePageTransitions && (event.type == 'DOMContentLoaded' || event.type == 'load')) {
    body.classList.add('animate__animated');
    body.classList.add('animate__' + animatePageTransitionsStyle);
  }
  
  // Animates sections
  if (animateSections) {
    shopifySections.forEach((element) => {
      var section = element.querySelector('.custom-section');
      
      if (isInViewport(section)) {
        section.classList.add('animate__animated');
        section.classList.add('animate__' + animateSectionsStyle);
      }
    });
  }
  
  // Animates sections backgrounds
  if (animateSectionsBackgrounds) {
    sectionsBgImages.forEach((element) => {
      if (isInViewport(element)) {
        element.classList.add('animate__animated');
        element.classList.add('animate__' + animateSectionsBackgroundsStyle);
      }
    });
  }
  
  // Animates images
  if (animateImages) {
    sectionsImages.forEach((sectionsImage) => {
      var images = sectionsImage.querySelectorAll('img');

      if (images.length == 0) images = sectionsImage.querySelectorAll('svg');

      images.forEach((image) => {
        if (isInViewport(image)) {
          sectionsImage.classList.add('animate__animated');
          image.classList.add('animate__' + animateImagesStyle);
        } else {
          sectionsImage.classList.remove('animate__animated');
          image.classList.remove('animate__' + animateImagesStyle);
        }
      });
    });
  }
  
  // Animates floating images
  if (animateFloatingImages) {
    sectionsFloatingImages.forEach((sectionsImage) => {
      var images = sectionsImage.querySelectorAll('img');

      if (images.length == 0) images = sectionsImage.querySelectorAll('svg');

      images.forEach((image) => {
        if (isInViewport(image)) {
          sectionsImage.classList.add('animate__animated');
          image.classList.add('animate__' + animateFloatingImagesStyle);
        } else {
          sectionsImage.classList.remove('animate__animated');
          image.classList.remove('animate__' + animateFloatingImagesStyle);
        }
      });
    });
  }
  
  // Animates buttons
  if (animateButtons) {
    sectionsButtons.forEach((element) => {
      var button = element.querySelector('.button');
      
      if (isInViewport(button)) {
        element.classList.add('animate__animated');
        button.classList.add('animate__' + animateButtonsStyle);
      } else {
        element.classList.remove('animate__animated');
        button.classList.remove('animate__' + animateButtonsStyle);
      }
    });
  }

  // Animates texts (by paragraph)
  if (animateTexts) {
    sectionsTexts.forEach((element) => {
      var text = element;
      
      if (isInViewport(text)) {        
        element.classList.add('animate__animated');
        text.classList.add('animate__' + animateTextsStyle);
      }
    });
  }
}

// Starts countdowns
function startCountdowns() {
  var countdowns = document.querySelectorAll(".countdown");
  
  countdowns.forEach((element) => {
    var dateValue = element.dataset.dateValue.split(','),
        year = parseInt(dateValue[0]),
        month = parseInt(dateValue[1]),
        day = parseInt(dateValue[2]),
        hours = parseInt(dateValue[3]),
        minutes = parseInt(dateValue[4]),
        seconds = parseInt('0'),
        now = new Date();

    if (dateValue[0] == '#') year = parseInt(now.getFullYear());
    if (dateValue[1] == '#') month = parseInt(now.getMonth());
    if (dateValue[2] == '#') day = parseInt(now.getDate());
    
    var countdownDate = new Date(year,month,day,hours,minutes,seconds).getTime(),
        expiredMessage = element.dataset.expiredMessage;

    // Creates a first countdown
    createCountdown(element, countdownDate, expiredMessage, x);

    // Updates the countdown every second
    var x = setInterval(function() {
      createCountdown(element, countdownDate, expiredMessage, x);
    }, 1000);
  });
}

// Creates a countdown
function createCountdown(countdown, countdownDate, expiredMessage, x) {
  var now = new Date().getTime(),
      distance = countdownDate - now,
      days = Math.floor(distance / (1000 * 60 * 60 * 24)),
      hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
      seconds = Math.floor((distance % (1000 * 60)) / 1000),
      countdownText = days + window.languages.shortDay + " " + hours + window.languages.shortHour + " " + minutes + window.languages.shortMinute + " " + seconds + window.languages.shortSecond + " ";

  if (days == 0) countdownText = hours + window.languages.shortHour + " " + minutes + window.languages.shortMinute + " " + seconds + window.languages.shortSecond + " ";  
  countdown.textContent = countdownText;

  // If the countdown is finished, a message is displayed
  if (distance < 0) {
    clearInterval(x);
    countdown.textContent = expiredMessage;
  }
}

// Starts the dynamic number count
function startDynamicNumbers() {
  var scrolled = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop,
      dynamicNumbers = document.querySelectorAll('.dynamic-number:not(.animated)');
  
  dynamicNumbers.forEach((element) => {      
    var numberValueText = element.textContent.replace(' ', '').replace(',', '').replace('.', ''),
        numberValue = parseInt(numberValueText),
        section = element.closest('.section'),
        offSetTop = getOffset(section).top,
        sectionHeight = section.clientHeight;
    
    if (scrolled + winHeightPadded > offSetTop && scrolled < offSetTop + sectionHeight) {
      animateValue(element, 0, numberValue, 2000);
      element.classList.add('animated');
    }
  });
}

// Checks if any footer spacer blocks should disappear depending on the screen size
function checkFooter() {
  var footer = document.querySelector('.section__page.footer'),
      footerModulesSpacer = footer.querySelectorAll('.footer__module--spacer, .footer__module--spacer_basic');

  footerModulesSpacer.forEach((element) => {
    var span = element.querySelector('span');

    if (window.innerWidth < 650 && span.dataset.showMobile == 'false') element.remove();
    if (window.innerWidth >= 650 && window.innerWidth < 1025 && span.dataset.showTablet == 'false') element.remove();
    if (window.innerWidth >= 1025 && span.dataset.showDesktop == 'false') element.remove();
  });
}

// Checks the contents of the cart
function checkCartContent() {
  checkCartState();
  checkFreeGifts();
  checkAddonsContent();
}

// Checks the status of the cart and its number of items
function checkCartState() {
  isPage('/cart') ? displayCartPage() : displayCartSidebar();
}

// Displays the right sections and blocks on the shopping cart page
function displayCartPage() {
  var sectionsCustomSection = document.querySelector('.main').querySelectorAll('.shopify-section'),
      sectionCartItems = document.querySelectorAll('.block__grid-cart-items');

  // If the cart is empty
  if (sectionCartItems.length == 0) {
    sectionsCustomSection.forEach((element, index) => {
      if (index == 0) {
        var hiddenBlocks = element.querySelectorAll('.block[data-hide-on-load="true"]'),
            shownBlocks = element.querySelectorAll('.block[data-hide-on-load="false"], .block:not([data-hide-on-load="true"])');

        shownBlocks.forEach((element) => {
          element.remove();
        });
        hiddenBlocks.forEach((element) => {
          element.style.display = 'block';
        });
      } else {
        element.remove();
      }
    });
  // If the cart is not empty
  } else {        
    sectionsCustomSection.forEach((element, index) => {
      if (index > 0) {            
        var hiddenBlocks = element.querySelectorAll('.block[data-hide-on-load="true"]');

        hiddenBlocks.forEach((element) => {
          element.style.display = 'block';
        });
      }
    });
  }
}

// Displays the right blocks on the side cart
function displayCartSidebar() {
  var sectionCartSidebar = document.querySelector('.shopify-section__cart-sidebar'),
      sectionCartItems = sectionCartSidebar.querySelectorAll('.block__grid-cart-items');

  // If the cart is empty
  if (sectionCartItems.length == 0) {
    var hiddenBlocks = sectionCartSidebar.querySelectorAll('.block:not(.block__cart-reassurance):not(.block__carousel)[data-hide-on-load="true"]'),
        shownBlocks = sectionCartSidebar.querySelectorAll('.block[data-hide-on-load="false"], .block:not([data-hide-on-load="true"])');

    shownBlocks.forEach((element) => {
      element.remove();
    });
    hiddenBlocks.forEach((element) => {
      element.style.display = 'block';
    });
  // If the cart is not empty
  } else {
    var hiddenBlocks = sectionCartSidebar.querySelectorAll('.block.block__cart-reassurance[data-hide-on-load="true"], .block.block__carousel[data-hide-on-load="true"]');

    hiddenBlocks.forEach((element) => {
      element.style.display = 'block';
    });
    startCarousels(false);
  }
}

// Checks free gifts
function checkFreeGifts() {
  var container = '';
  
  isPage('/cart') ? container = document.querySelector('.main') : container = document.querySelector('.cart-sidebar');

  var progressBar = container.querySelector('.cart-progress-bar[data-type="several-treshold"]');

  if (progressBar !== null) {
    fetch(`${routes.cartUrl}`, { ...fetchConfig('GET') })
      .then((response) => response.text())
      .then((response) => {   
        const results = JSON.parse(response);
        var progressBarOffers = progressBar.querySelectorAll('.cart-progress-bar-step[data-variant-id]'),
            cartTotalPrice = results.total_price,
            variantsToAdd = [];

        progressBarOffers.forEach((element) => {
          var offerVariantId = element.dataset.variantId,
              offerTreshold = parseInt(element.dataset.treshold),
              itemCart = container.querySelector('.item-cart[data-variant-id="' + offerVariantId + '"]');

          if (cartTotalPrice >= offerTreshold) {
            if (itemCart === null) variantsToAdd.push(offerVariantId);
          } else {
            if (itemCart !== null) itemCart.querySelector('.cart-item-remove').click();
          }
        });
        
        if (variantsToAdd.length > 0) {
          Shopify.queue = [];
          for (let i = 0; i < variantsToAdd.length; i++) {
            addVariantToQueue(variantsToAdd[i], 1, 0, new Object());
          }
          Shopify.moveAlong(null);
        }
      });
  }
}

// Removes from the carousel addons the items that already are in the cart
function checkAddonsContent() {
  var container = '';
  
  isPage('/cart') ? container = document.querySelector('.main').querySelector('.section--addons') : container = document.querySelector('.cart-sidebar');

  fetch(`${routes.cartUrl}`, { ...fetchConfig('GET') })
      .then((response) => response.text())
      .then((response) => {   
        const results = JSON.parse(response);
        var cartItems = results.items;

        for (let i = 0; i < cartItems.length; i++) {
          var handle = cartItems[i].handle,
              addonItem = container.querySelector('.carousel-cell .item-product[data-item-handle="' + handle + '"]');
          
          if (addonItem !== null) {
            var carousel = addonItem.closest('.carousel'),
                carouselCell = addonItem.closest('.carousel-cell'),
                style = carouselCell.querySelector('.carousel-cell--wrapper').parentNode.querySelector('style'),
                nextElementSibling = carouselCell.nextElementSibling;
    
            if (style !== null && nextElementSibling !== null) nextElementSibling.querySelector('.carousel-cell--inner').prepend(style);    
            carouselCell.remove();
            if (isSliderInitialized(carousel)) carousel.swiper.update();
            
            // If all the addons have been added to cart, we delete the section
            if (container.querySelector('.item-product') === null) {
              if (isPage('/cart')) {
                carousel.closest('.shopify-section').remove();
              } else {
                carousel.closest('.shopify-block').previousElementSibling.remove();
                carousel.closest('.shopify-block').remove();
              }
            }        
          }
        }
      });
}

// Manages the sticky header display
function handleStickyHeader() {
  var stickyHeader = document.querySelector('.header-bar[data-sticky="all"]');

  if (window.innerWidth < 650) {
    stickyHeader = document.querySelector('.header-bar[data-sticky="all"], .header-bar[data-sticky="mobile"], .header-bar[data-sticky="portable"]');
    stickyAnnouncement = document.querySelector('.announcement-bar[data-sticky="all"], .announcement-bar[data-sticky="mobile"], .announcement-bar[data-sticky="portable"]');
  } else if (window.innerWidth < 1201) {
    stickyHeader = document.querySelector('.header-bar[data-sticky="all"], .header-bar[data-sticky="mobile"], .header-bar[data-sticky="portable"], .header-bar[data-sticky="tablet"], .header-bar[data-sticky="handheld-and-up"]');
    stickyAnnouncement = document.querySelector('.announcement-bar[data-sticky="all"], .announcement-bar[data-sticky="mobile"], .announcement-bar[data-sticky="portable"], .announcement-bar[data-sticky="tablet"], .announcement-bar[data-sticky="handheld-and-up"]');
  } else if (window.innerWidth >= 1201) {
    stickyHeader = document.querySelector('.header-bar[data-sticky="all"], .header-bar[data-sticky="handheld-and-up"], .header-bar[data-sticky="desktop"]');
    stickyAnnouncement = document.querySelector('.announcement-bar[data-sticky="all"], .announcement-bar[data-sticky="handheld-and-up"], .announcement-bar[data-sticky="desktop"]');
  }

  if (stickyHeader !== null) {
    var shopifySection = stickyHeader.closest('.shopify-section'),
        announcementBar = document.querySelector('.section__page.announcement-bar'),
        announcementBarHeight = announcementBar.clientHeight,
        headerTop = 0;

    if (stickyAnnouncement !== null) headerTop = announcementBarHeight;
    shopifySection.style.top = headerTop + 'px';
  }
}

// Manages the landing page url
function handleLandingPage() {
  var body = document.querySelector('body');       

  // Saves the landing page url
  if (body.classList.contains('template-index') || body.classList.contains('template-page-lp')) {
    window.localStorage.setItem('landing_page', window.location.pathname);
  } else {
    if (window.localStorage.getItem('landing_page') === null) window.localStorage.setItem('landing_page', '/');
  }

  // Assigns the url of the landing page to the necessary elements
  var logos = document.querySelectorAll('.logo'),        
      navigationBack = document.querySelector('.navigation-back .navigation-horizontal__list-link'),
      selectorStepPrevious = document.querySelector('.selector-step--previous'),
      previousButton = document.querySelector('.selector-step--previous .button'),
      pathname = window.localStorage.getItem('landing_page');

  logos.forEach((element) => {
    element.querySelector('.logo__link').setAttribute('href', pathname);
  });

  if (navigationBack !== null && navigationBack.getAttribute('data-default-url') == 'false') navigationBack.setAttribute('href', pathname);
  if (selectorStepPrevious !== null && selectorStepPrevious.getAttribute('data-default-url') == 'false') previousButton.setAttribute('href', pathname);
}

// Processes the parameters in the url to perform load-specific actions
function handleUrlParameters() {
  var pathname = window.location.pathname,
      hash = window.location.hash,
      search = window.location.search;
  
  if (hash != "") {
    switch (hash) {
      case '#contact':
        openContactForm(hash, search, 'section--contact-form');
        break;
      case '#frequently-asked-questions': // EN
      case '#order-delivery':
      case '#questions-frequentes': // FR
      case '#commande-livraison':
        openCategory(hash, search, 'section--faq');
        break;
      case '#my-orders': // EN
      case '#my-subscriptions':
      case '#my-information':
      case '#referral-program':
      case '#mes-commandes': // FR
      case '#mes-abonnements':
      case '#mes-informations':
      case '#programme-de-parrainage':
        openCategory(hash, search, 'section--customer-account');
        break;
      default:          
    }
  }
  
  if (search != "") {
    switch (search) {
      case '?contact_posted=true':
        openContactForm(hash, search, 'section--contact-form');
        break;
      default:          
    }
  }

  if (hash === '#recover' || window.recoverPassword === true) document.querySelector('[data-action="toggle-recover-form"]').click();
}

// Opens the contact form
function openContactForm(hash, search, sectionToScroll) {
  var hashValue = hash.substring(1),
      sectionId = '#' + sectionToScroll,
      sectionClass = '.' + sectionToScroll,
      sectionPage = document.querySelector(sectionClass),
      contactButton = sectionPage.querySelector('.button[data-action="show-hidden-blocks"]');

  if (sectionToScroll !== '') window.location.href = sectionId;
  if (contactButton !== null) contactButton.click();
}

// Opens a category
function openCategory(hash, search, sectionToScroll) {
  var hashValue = hash.substring(1),
      sectionId = '#' + sectionToScroll,
      sectionClass = '.' + sectionToScroll,
      sectionPage = document.querySelector(sectionClass),
      categoryTitle = document.querySelector('.category-title[data-category-handle="' + hashValue + '"]');

  if (sectionToScroll !== '') window.location.href = sectionId;
  if (categoryTitle !== null) categoryTitle.click();
}

// Opens the sidebars
function openSidebars() {
  var sidebars = document.querySelectorAll('.sidebar[data-sidebar-open="true"]');

  sidebars.forEach((element) => {
    var sidebarClass = element.getAttribute('class').split(' ').pop(),
        triggerSelector = '[data-action="open-' + sidebarClass + '"]',
        trigger = document.querySelector(triggerSelector);

    trigger.click();
  });
}

// Opens the modals
function openModals(trigger) {
  var modals = document.querySelectorAll('.modal[data-trigger="' + trigger + '"]');

  modals.forEach((element) => {
    var modalId = element.getAttribute('id'),
        modalDelay = element.dataset.delay * 1000,
        modalShowOnce = element.dataset.showOnce,
        alreadyShown = sessionStorage.getItem(modalId);

    if (modalShowOnce == 'false' || alreadyShown != 'true') {
      setTimeout(() => {
        openModalWithId(modalId, event);
        
        if (modalShowOnce == 'true') sessionStorage.setItem(modalId, 'true');
      }, modalDelay);
    }
  });
}

// Saves the viewed product in the session storage
function saveViewedProduct() {
  if (isPage('/products/')) {
    var productHandle = window.location.pathname.split('/products/').pop().split('?').shift(),
        productsRecentlyViewed = sessionStorage.getItem('recently_viewed'),
        count = 0,
        limit = 10;

    productsRecentlyViewed === null ? productsRecentlyViewed = '' : count = productsRecentlyViewed.split(',').length - 1;

    if (count < limit && productsRecentlyViewed.indexOf(productHandle) == -1) {
      var productHandles = productsRecentlyViewed + productHandle + ',';

      sessionStorage.setItem('recently_viewed', productHandles);
    }
  }
}

// Changes the active button that filter products types in collection template
function changeActiveProductTypeInCollection() {
  if (isPage('/collections/')) {
    var currentCollection = window.location.pathname.split('/').pop(),
        buttonsGroup = document.querySelector('[data-name="buttons-group-product-type"]'),
        oldActiveButton = buttonsGroup.querySelector('.active'),
        newActiveButton = buttonsGroup.querySelector('[href="/collections/' + currentCollection + '"]').closest('.button-wrapper');

    oldActiveButton.classList.remove('active');
    newActiveButton.classList.add('active');
  }
}

/**
 * ON SCROLL
 */

// On page scroll
window.addEventListener('scroll', scrollHandler);

// On page scroll that needs throttle
window.addEventListener('scroll', throttle(() => {
  scrollThrottleHandler();
}, 1000));

// On page scroll that should happen only once
window.addEventListener('scroll', () => {
  scrollOneHandler();
}, {
  once: true,
});

// On page scroll
function scrollHandler() {
  handleToggleHeader();
  handleStickyATC();
  startDynamicNumbers();
  startVideos();
  startAnimations();
}

// On page scroll that needs throttle
function scrollThrottleHandler() {
  startInfiniteScroll();
}

// On page scroll that should happen only once
function scrollOneHandler() {
  openModals('scroll');
}

// Manages the display of the toggle header
function handleToggleHeader() {
  var toggleHeader = document.querySelector('.header-bar[data-toggle-scroll="all"]');

  if (window.innerWidth < 650) {
    toggleHeader = document.querySelector('.header-bar[data-toggle-scroll="all"], .header-bar[data-toggle-scroll="mobile"], .header-bar[data-toggle-scroll="portable"]');
  } else if (window.innerWidth < 1201) {
    toggleHeader = document.querySelector('.header-bar[data-toggle-scroll="all"], .header-bar[data-toggle-scroll="mobile"], .header-bar[data-toggle-scroll="portable"], .header-bar[data-toggle-scroll="tablet"], .header-bar[data-toggle-scroll="handheld-and-up"]');
  } else if (window.innerWidth >= 1201) {
    toggleHeader = document.querySelector('.header-bar[data-toggle-scroll="all"], .header-bar[data-toggle-scroll="handheld-and-up"], .header-bar[data-toggle-scroll="desktop"]');
  }

  if (toggleHeader !== null) {
    var shopifySection = toggleHeader.closest('.shopify-section'),
        verticalScrollDirection = getVerticalScrollDirection(),
        scrolled = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    
    if (verticalScrollDirection == 'down') { 
      if (scrolled > 0) toggleHeader.classList.add('is-sticky');
      
      if (scrolled >= 250 && hasFaded === 0) {
        shopifySection.style.transition = 'opacity 0.4s';
        shopifySection.style.opacity = '0';
        hasFaded = 1;
      }

      position = scrolled;        
    } else if (verticalScrollDirection == 'up') {  
      if (scrolled == 0) toggleHeader.classList.remove('is-sticky');
      
      if (hasFaded === 1) {
        shopifySection.style.transition = 'opacity 0.4s';
        shopifySection.style.opacity = '1';
        hasFaded = 0;
      }

      position = scrolled;        
    }
  }
}

// Manages the display of the sticky atc section
function handleStickyATC() {
  var triggerSection = document.querySelector('.section--product'),
      stickyAtcSection = document.querySelector('.section--sticky-atc');

  if (triggerSection !== null && stickyAtcSection !== null) {    
    !isInViewport(triggerSection) ? stickyAtcSection.style.display = 'block' : stickyAtcSection.style.display = 'none';
  }
}

// Starts the videos
function startVideos() {
  var scrolled = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop,
      videosWrappers = '';
  
  window.innerWidth < 650 ? videosWrappers = document.querySelectorAll('.video-wrapper--file.hidden-handheld-and-up, .video-wrapper--file.all') : videosWrappers = document.querySelectorAll('.video-wrapper--file.hidden-thumb, .video-wrapper--file.all');
  
  videosWrappers.forEach((element) => {
    var video = element.querySelector('[data-play-scroll="true"]');
    
    if (video !== null) {
      var videoButton = element.querySelector('button'),
          offSetTop = getOffset(video).top,
          videoHeight = video.clientHeight;

      if (scrolled + winHeightPadded > offSetTop && scrolled < offSetTop + videoHeight) {
        if (video.paused) {
          videoButton.classList.remove('active');
          video.play().catch((error) => {
            videoButton.classList.add('active');
          }); 
          
          if (video.getAttribute('data-unmute-scroll') == "true") video.muted = false;
        }
      } else {
        if (!video.paused) {
          video.pause();
          video.muted = true;
        }
      }
    }
  });
}

// Manages the infinite scroll feature on grid items
function startInfiniteScroll() {
  var scrolled = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop,
      paginations = document.querySelectorAll('[data-paginate-type="infinite-scroll"]:not(.complete)');
  
  paginations.forEach((element) => {      
    var offSetTop = getOffset(element).top,
        sectionHeight = element.clientHeight;
    
    if (scrolled + winHeightPadded > offSetTop && scrolled < offSetTop + sectionHeight) loadMoreGridItems(element);
  });
}

/**
 * ----------------------------------------------------------------------------------------------------
 * ANIMATIONS
 * ----------------------------------------------------------------------------------------------------
 */

/**
 * GENERAL
 */

// When the mouse comes out of the page
document.querySelector('html').addEventListener('mouseleave', exitPageHandler);

// When the mouse comes out of the page
function exitPageHandler() {
  openModals('exit');
}

setupEventListenersForLogoAnimation();

// Creates the event listeners
function setupEventListenersForLogoAnimation() {
  // When the mouse enters a store logo
  document.querySelectorAll('.logo-wrapper').forEach((element) => {
    element.addEventListener('mouseenter', changeLogoHover);
  });
  
  // When the mouse comes out a store logo
  document.querySelectorAll('.logo-wrapper').forEach((element) => {
    element.addEventListener('mouseleave', changeLogoHover);
  });
}

// Changes the store logo when hovering (On desktop only)
function changeLogoHover() {
  var target = event.currentTarget;
  
  if (window.innerWidth >= 1025) {
    var logoMain = target.querySelector('.logo-main'),
        logoHover = target.querySelector('.logo-hover');

    if (logoHover !== null) {
      logoMain.classList.toggle('hidden');
      logoHover.classList.toggle('hidden');
    }
  }
}

/**
 * SHOW MORE
 */

setupEventListenersForShowMoreAnimation();

// Creates the event listeners
function setupEventListenersForShowMoreAnimation() {
  // On show more button click
  document.querySelectorAll('[data-action="show-more"]').forEach((element) => {
    element.addEventListener('click', expandShowMore);
  });
}

// Shows more elements in a list
function expandShowMore() {
  var target = event.currentTarget,
      parent = target.closest('.show-more-parent'),
      hiddenItems = parent.querySelectorAll('.show-more-item'),
      labels = target.querySelectorAll('[class^="label-show-"]');

  hiddenItems.forEach((element) => {
    element.classList.toggle('hidden');
  });
  labels.forEach((element) => {
    element.classList.toggle('hidden');
  });
}

/**
 * LOAD MORE (GRID ITEMS)
 */

setupEventListenersForPagination();

// Creates the event listeners
function setupEventListenersForPagination() {
  // On pagination load more button click
  document.querySelectorAll('.pagination__nav--load-more').forEach((element) => {
    element.addEventListener('click', clickLoadMoreGridItemsHandler);
  });
}

// Shows more elements in a grid
function clickLoadMoreGridItemsHandler() {
  loadMoreGridItems(event.currentTarget);
}

// Shows more elements in a grid
function loadMoreGridItems(target) {
  var sectionPage = target.closest('.section__page'),
      gridProducts = sectionPage.querySelector('.grid__products'),
      pagination = gridProducts.parentNode.querySelector('.pagination'),
      paginationType = pagination.dataset.paginateType,
      totalPages = parseInt(pagination.dataset.totalPage),
      currentPage = parseInt(pagination.dataset.currentPage),
      nextUrl = target.getAttribute('href');

  event.preventDefault();
  
  if (paginationType == 'infinite-button') {
    target.setAttribute('disabled', true);
    target.querySelector('.button-text').classList.add('hidden');
  }

  if (paginationType == 'infinite-scroll') nextUrl = target.querySelector('[loader]').dataset.href; 
  target.querySelector('[loader]').classList.remove('hidden');

  fetch(nextUrl)
    .then((response) => response.text())
    .then((text) => {
      var container = document.createElement('div');
      
      container.innerHTML = text;

      var responseProducts = container.querySelector('[data-products-source="collection"]').querySelector('.grid__products').querySelectorAll('.grid__cell'),
          firstProductId = responseProducts[0].querySelector('.item-product').getAttribute('id'),
          productLayoutSwitcher = document.querySelector('.products__layout-button.selected[data-action="change-layout"]');
  
      if (gridProducts.querySelector('#' + firstProductId) === null) {
        for (let i = 0; i < responseProducts.length; i++) {
          gridProducts.appendChild(responseProducts[i]);
        }
        if (productLayoutSwitcher !== null) productLayoutSwitcher.click();
        pagination.innerHTML = container.querySelector('.pagination').innerHTML;
        setupEventListenersAfterFetchingProductsPagination();
      }  
    })
    .finally(() => {
      currentPage = parseInt(pagination.dataset.currentPage) + 1;
      pagination.setAttribute('data-current-page', currentPage);
      
      if (currentPage >= totalPages) {        
        if (paginationType == 'infinite-button') pagination.querySelector('.pagination__nav--load-more').remove();
        pagination.classList.add('complete');
      }
    })
    .catch((event) => {
      console.error(event);
    });
}

// Creates the event listeners needed after fetch
function setupEventListenersAfterFetchingProductsPagination() {
  setupEventListenersForProductsItems();
  setupEventListenersForPagination();
}

/**
 * COLLAPSIBLE
 */

setupEventListenersForCollapsible();

// Creates the event listeners
function setupEventListenersForCollapsible() {
  // On collapsible item click
  document.querySelectorAll('.collapsible .collapsible-header').forEach((element) => {
    element.addEventListener('click', toggleCollapsibleContent);
  });
}

// Opens or closes the content of a collapsible item
function toggleCollapsibleContent() {
  var target = event.currentTarget,
      collapsible = target.closest('.collapsible'),
      collapsibleHeader = collapsible.querySelector('.collapsible-header'),
      collapsibleContent = collapsible.querySelector('.collapsible-content');    
  
  collapsibleHeader.setAttribute('aria-expanded', (collapsibleHeader.getAttribute('aria-expanded') === 'false').toString());
  collapsible.classList.toggle('opened');
}

/**
 * TABS
 */

setupEventListenersForTabs();

// Creates the event listeners
function setupEventListenersForTabs() {
  // On tab item click
  document.querySelectorAll('.tabs .tab__header').forEach((element) => {
    element.addEventListener('click', toggleTabContent);
  });
}

// Opens the content of a tab item
function toggleTabContent() {
  var target = event.currentTarget,
      tabNumber = target.dataset.tabNumber,
      tabs = target.closest('.tabs'),
      tabContent = tabs.querySelector('.tab__content[data-tab-number="' + tabNumber + '"]');

  tabs.querySelector('.tab__header.active').setAttribute('aria-selected', false);
  tabs.querySelector('.tab__header.active').classList.remove('active');    
  tabs.querySelector('.tab__content.active').classList.remove('active');

  target.setAttribute('aria-selected', true);
  target.classList.add('active');    
  tabContent.classList.add('active');
}

/**
 * DROPDOWNS SELECTS
 */

setupEventListenersForDropdownsSelects();

// Creates the event listeners
function setupEventListenersForDropdownsSelects() {
  // On popover button click
  document.querySelectorAll('.popover .popover__button').forEach((element) => {
    element.addEventListener('click', openPopover);
  });
  
  // On popover button focusout
  document.querySelectorAll('.popover .popover__button').forEach((element) => {
    element.addEventListener('focusout', closePopover);
  });
}

// Opens the content of a popover
function openPopover() {
  var target = event.currentTarget,
      popoverPanelId = target.getAttribute('aria-controls'),
      popoverPanel = target.parentNode.querySelector('.popover__panel');

  if (popoverPanel === null) popoverPanel = document.querySelector('#' + popoverPanelId);

  target.focus();
  target.setAttribute('aria-expanded', (target.getAttribute('aria-expanded') === 'false').toString());
  popoverPanel.classList.toggle('hidden');
}

// Closes the content of a popover
function closePopover() {
  var target = event.currentTarget,
      popoverPanelId = target.getAttribute('aria-controls'),
      popoverPanel = target.parentNode.querySelector('.popover__panel');

  if (popoverPanel === null) popoverPanel = document.querySelector('#' + popoverPanelId);
  
  const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  
  if (event.relatedTarget === null || shouldClose) {
    target.setAttribute('aria-expanded', 'false');
    popoverPanel.classList.add('hidden');
  }
}

/**
 * SIDEBARS
 */

// Calculates sidebar contents height
function setSidebarContentsHeight(sidebarName) {
  var sidebarSelector = '.section__page.' + sidebarName + '-sidebar',
      sidebar = document.querySelector(sidebarSelector),
      sidebarContents = sidebar.querySelector('.sidebar__contents'),
      sidebarHeight = sidebar.clientHeight,
      sidebarHeaderHeight = sidebar.querySelector('.sidebar__header').clientHeight,
      sidebarAddons = sidebar.querySelector('.sidebar__addons'),
      sidebarAddonsHeight = 0,
      sidebarFooterHeight = sidebar.querySelector('.sidebar__footer').clientHeight;

  if (sidebarAddons !== null) sidebarAddonsHeight = sidebarAddons.clientHeight;

  sidebarContentsHeight = sidebarHeight - sidebarHeaderHeight - sidebarAddonsHeight - sidebarFooterHeight
  sidebarContents.style.maxHeight = sidebarContentsHeight + 'px';

  if (sidebarName == 'filters') {
    var filterForm = sidebar.querySelector('.products-filters--drawer').querySelector('.filter-form'),
        filtersButtons = filterForm.querySelector('.filters-buttons'),
        filtersButtonsHeight = 0;

    if (filtersButtons !== null) filtersButtonsHeight = filtersButtons.clientHeight;
        
    var filterFormHeight = sidebarContentsHeight - filtersButtonsHeight;

    filterForm.style.height = filterFormHeight + 'px';
  }
}

// Opens or closes a sidebar
function toggleSidebar(sidebarName) {
  var sidebarSelector = '.section__page.' + sidebarName + '-sidebar',
      sidebar = document.querySelector(sidebarSelector),
      html = document.querySelector('html'),
      pageOverlay = document.querySelector('.page__overlay');
  
  // Additional calculations are required to ensure that the full content of the sidebar is visible
  setSidebarContentsHeight(sidebarName);
  
  sidebar.classList.toggle('sidebar--open');
  pageOverlay.classList.toggle('page__overlay--open');
  html.classList.toggle('no-scroll');

  if (sidebar.classList.contains('sidebar--open')) {
    if (sidebarName == 'navigation') {
      // This fixes a problem on Safari where the list may not be focused
      sidebar.addEventListener('transitionend', () => {document.querySelector('.navigation-sidebar__list--active').focus();}, {once: true,});
      sidebar.addEventListener('webkitTransitionEnd', () => {document.querySelector('.navigation-sidebar__list--active').focus();}, {once: true,});
      sidebar.addEventListener('oTransitionEnd', () => {document.querySelector('.navigation-sidebar__list--active').focus();}, {once: true,});
    }
    
    pageOverlay.addEventListener('click', () => {
      closeSidebar(sidebarName);
    });
  } else {
    pageOverlay.removeEventListener('click', () => {
      closeSidebar(sidebarName);
    });
  }

  return false;
}

// Closes a sidebar
function closeSidebar(sidebarName) {
  var sidebarSelector = '.section__page.' + sidebarName + '-sidebar',
      sidebar = document.querySelector(sidebarSelector),
      html = document.querySelector('html'),
      pageOverlay = document.querySelector('.page__overlay');
  
  sidebar.classList.remove('sidebar--open');
  pageOverlay.classList.remove('page__overlay--open');
  html.classList.remove('no-scroll');
  pageOverlay.removeEventListener('click', () => {
    closeSidebar(sidebarName);
  });
}; 

/**
 * MODALS
 */

setupEventListenersForModals();

// Creates the event listeners
function setupEventListenersForModals() {
  // On clicking on a link that opens a modal
  document.querySelectorAll('[data-action="open-modal"]').forEach((element) => {
    element.addEventListener('click', clickOpenModalHandler);
  });
  
  // On clicking on a link that opens a modal with a specific id
  document.querySelectorAll('[data-action^="open-modal-with-id"]').forEach((element) => {
    element.addEventListener('click', clickOpenModalWithIdHandler);
  });
  
  // On clicking on a link that closes a modal
  document.querySelectorAll('[data-action="close-modal"]').forEach((element) => {
    element.addEventListener('click', clickCloseModalHandler);
  });
  
  // On clicking on a link that closes a modal with a specific id
  document.querySelectorAll('[data-action^="close-modal-with-id"]').forEach((element) => {
    element.addEventListener('click', clickCloseModalWithIdHandler);
  });
}

// On modal closed
document.addEventListener('modal.closed', modalClosedHandler);

// On clicking on a link that opens a modal
function clickOpenModalHandler() {
  openModal();
}

// On clicking on a link that opens a modal with a specific id
function clickOpenModalWithIdHandler() {
  var target = event.currentTarget,
      actionAttribute = target.getAttribute('data-action'),
      modalId = 'modal-' + actionAttribute.split('open-modal-with-id-').pop();
  
  openModalWithId(modalId);
}

// On clicking on a link that closes a modal
function clickCloseModalHandler() {
  closeModal();
}

// On clicking on a link that closes a modal with a specific id
function clickCloseModalWithIdHandler() {
  var target = event.currentTarget,
      actionAttribute = target.getAttribute('data-action'),
      modalId = 'modal-' + actionAttribute.split('close-modal-with-id-').pop();
  
  closeModalWithId(modalId);
}

// On modal closed
function modalClosedHandler() {
  var modal = event.detail;

  // When the quick shop popup is closed, the small spinner must be added again
  if (modal.classList.contains('modal--quick-shop')) closeQuickShop();
}

// Opens a modal
function openModal() {
  var target = event.currentTarget,
      modalId = target.dataset.modalId;
  
  if (!modalId) modalId = target.parentNode.dataset.modalId;
  
  var modal = document.querySelector('#' + modalId);
  
  showModal(modal);
}

// Opens a modal with an id as parameter
function openModalWithId(modalId) {
  var modal = document.querySelector('#' + modalId);

  showModal(modal);
}

// Displays the modal
function showModal(modal) {
  if (modal !== null) {
    modal.showModal();
    document.documentElement.classList.add('modal-is-locked');
    if (event != null) event.preventDefault();
    
    modal.addEventListener('click', () => {
      if (event.target.closest('.modal--inner') === null) closeModalWithId(modal.id);
    });
  }
}

// Closes a modal
function closeModal() { 
  var target = event.currentTarget,
      modal = target.closest('.modal');
  
  hideModal(modal);
}

// Closes a modal with an id as parameter
function closeModalWithId(modalId) {
  var modal = document.querySelector('#' + modalId);
  
  hideModal(modal);
}

// Hides the modal
function hideModal(modal) {
  if (modal !== null) {
    modal.close();
    document.documentElement.classList.remove('modal-is-locked');
    if (event != null) event.preventDefault();
    document.dispatchEvent(new CustomEvent('modal.closed', { detail: modal }));
  }
}

/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCTS
 * ----------------------------------------------------------------------------------------------------
 */

/**
 * PRODUCTS - SELECTOR / BUNDLE BUILDER
 */

// Checks if all selector steps are complete
function selectionComplete() {  
  // TODO (depending on the logic of the store)
  // TO CHECK FOR BUNDLES
  return selectorStepOneComplete() ? true : false;
}

// Checks if the first step of the selector is complete
function selectorStepOneComplete() {    
  var target = event.currentTarget,
      sectionPageBundleProducts = document.querySelector('.section__page[data-page-handle="bundle-products"]'),
      selectorStepProgressionWrapper = document.querySelector('.selector-step-progression-wrapper'),
      selectorStepProgression = selectorStepProgressionWrapper.querySelector('.selector-step-progression'),
      nbProducts = parseInt(selectorStepProgression.getAttribute('data-nb-products')),
      nbItemsSelected = parseInt(selectorStepProgression.getAttribute('data-nb-items-selected')),
      nbItemsMax = parseInt(selectorStepProgression.getAttribute('data-nb-items-max')),
      selectedProgressionItems = selectorStepProgressionWrapper.querySelectorAll('.step-progression-item.selected'),
      nbSelectedProgressionItems = selectedProgressionItems.length,
      selectedProgressionItemsWithSku = selectorStepProgressionWrapper.querySelectorAll('.step-progression-item.selected[data-variant-sku]:not([data-variant-sku=""])'),
      nbSelectedProgressionItemsWithSku = selectedProgressionItemsWithSku.length;
  
  // If the number of selected items is equal to (or greater than) the maximum number of selectable items
  // AND that the number of selected item progression is equal (or superior) to the maximum number of selectable items
  // AND that each item progression has a SKU value
  return nbItemsSelected >= nbProducts && nbSelectedProgressionItems >= nbItemsMax && nbSelectedProgressionItemsWithSku >= nbItemsMax ? true : false;
}

// Displays an error message
function showErrorsMessage(target) {
  if (target === null) target = event.target;
  target.removeAttribute('disabled');
  target.querySelector('span.button-text').textContent = target.dataset.buttonText;  
  if (!selectionComplete()) alert(window.languages.alertSelector);
}

/**
 * PRODUCTS - ADD TO CART
 */

// Adds a product to the cart from the product form
function addToCartFromProductForm() {
  try {
    var target = event.currentTarget,
        productForm = target.closest('.product-form'),
        addToCartButton = productForm.querySelector('.product__add-to-cart');
  
    if (productForm === null) {
      productForm = target.closest('.section__page').querySelector('.product-form');
      addToCartButton = target;
    }
    
    addToCartButton.querySelector('span.button-text').textContent = window.languages.addingToCartButton;
    if (addToCartButton.querySelector('span.button-price') !== null) addToCartButton.querySelector('span.button-price').classList.add('hidden');
    addToCartButton.setAttribute('disabled', 'disabled');
    
    var container = productForm.closest('.section__page'),
        id = productForm.dataset.variantId,
        quantity = container.querySelector('.product__quantity-value'),
        sellingPlan = container.querySelector('input[name="selling_plan"]'),
        productProperties = container.querySelectorAll('[name^="properties"]'),
        properties = new Object();
    
    quantity === null ? quantity = 1 : quantity = parseInt(quantity.textContent);
    if (isNaN(quantity)) quantity = quantity.value
    sellingPlan === null ? sellingPlan = 0 : sellingPlan = parseInt(sellingPlan.value);  
    
    productProperties.forEach((element) => {
      if (element.value != '') {
        var propertyName = element.getAttribute('name').split('[').pop().split(']').shift();
        
        properties[propertyName] = element.value;
      } else if (!element.disabled && element.required) {
        throw new Error(window.languages.errorRequiredField, { cause: 'requiredProperty' });
      }
    });
    
    addVariantToCart(addToCartButton, id, quantity, sellingPlan, properties);
  
    // Resets the quantity selector to its starting value
    setTimeout(() => {
      reinitQuantitySelector(container);
    }, 3000);
  } catch (error) {
    if (error.cause == 'requiredProperty') handleAddToCartError(addToCartButton, error);
  }
}

// Adds a product to the cart from a product item
function addToCartFromProductItem() {
  var target = event.currentTarget,
      itemProduct = target.closest('.item-product');

  if (itemProduct === null) itemProduct = target.closest('.item__footer').previousElementSibling;
  
  var addToCartButton = itemProduct.querySelector('.product__button').querySelector('.button'),
      id = itemProduct.dataset.variantId,
      quantity = 1,
      sellingPlan = 0,
      properties = new Object();
  
  addToCartButton.querySelector('span.button-text').textContent = window.languages.addingToCartButton;
  if (addToCartButton.querySelector('span.button-price') !== null) addToCartButton.querySelector('span.button-price').classList.add('hidden');
  addToCartButton.setAttribute('disabled', 'disabled');  
  addVariantToCart(addToCartButton, id, quantity, sellingPlan, properties);
}

// Adds a product to the cart from a bundle product item
function addToCartFromProductItemBundle() {
  var target = event.currentTarget,
      itemProduct = target.closest('.item-product');

  if (itemProduct === null) itemProduct = target.closest('.item__footer').previousElementSibling;
  
  var addToCartButton = itemProduct.querySelector('.product__button').querySelector('.button'),
      id = itemProduct.dataset.variantId,
      quantity = 1,
      sellingPlan = 0,
      properties = new Object();
  
  addToCartButton.querySelector('span.button-text').textContent = window.languages.addingToCartButton;
  if (addToCartButton.querySelector('span.button-price') !== null) addToCartButton.querySelector('span.button-price').classList.add('hidden');
  addToCartButton.setAttribute('disabled', 'disabled');  
  addBundleVariantToCart(addToCartButton, id, quantity, sellingPlan, properties, itemProduct);
}

// Adds products to the cart from a products list
function addToCartFromProductsList() {
  var target = event.currentTarget,
      container = target.closest('.section-column'),
      productLists = container.querySelectorAll('.carousel--products:not(.carousel--produ-comp)'),
      addToCartButton = target;
  
  if (productLists.length == 0) productLists = container.querySelectorAll('.grid__products');
  
  addToCartButton.querySelector('span.button-text').textContent = window.languages.addingToCartButton;
  if (addToCartButton.querySelector('span.button-price') !== null) addToCartButton.querySelector('span.button-price').classList.add('hidden');
  addToCartButton.setAttribute('disabled', 'disabled');  
  addVariantsToCart(addToCartButton, productLists);
}

// Adds products to the cart from a products selector
function addToCartFromProductsSelector() {
  var target = event.currentTarget,
      container = target.closest('.main'),
      productLists = container.querySelectorAll('.carousel--products:not(.carousel--produ-comp)'),
      addToCartButton = target;
  
  if (productLists.length == 0) productLists = container.querySelectorAll('.grid__products');
  
  addToCartButton.querySelector('span.button-text').textContent = window.languages.addingToCartButton;
  if (addToCartButton.querySelector('span.button-price') !== null) addToCartButton.querySelector('span.button-price').classList.add('hidden');
  addToCartButton.setAttribute('disabled', 'disabled');
  // Checks what kind of product we are adding // TO CHECK FOR BUNDLES*
  productLists[0].querySelector('.item-product[data-item-template-suffix="bundle-product"]') !== null ? addBundleVariantsToCart(addToCartButton, productLists) : addVariantsToCart(addToCartButton, productLists);
}

// Add products to the cart from a bundle builder
function addToCartFromBundleBuilder() {
  var target = event.currentTarget,
      addToCartButton = target;
  
  addToCartButton.querySelector('span.button-text').textContent = window.languages.addingToCartButton;
  if (addToCartButton.querySelector('span.button-price') !== null) addToCartButton.querySelector('span.button-price').classList.add('hidden');
  addToCartButton.setAttribute('disabled', 'disabled');  
  addBundleBuilderToCart(addToCartButton);
}

// Adds variants to the cart
function addVariantsToCart(addToCartButton, productLists) {    
  Shopify.queue = [];   
  
  var nbProductsSelected = 0,    
      productForm = addToCartButton.closest('.product__form');
  
  productLists.forEach((element) => {
    var itemsProduct = element.querySelectorAll('.item-product');
    
    itemsProduct.forEach((itemProduct) => {
      var id = itemProduct.dataset.variantId,
          quantity = itemProduct.querySelector('.product__quantity-value'),
          sellingPlan = itemProduct.querySelector('input[name="selling_plan"]'),
          properties = new Object();
      
      quantity === null ? quantity = 1 : quantity = parseInt(quantity.textContent);
      if (isNaN(quantity)) quantity = quantity.value
      sellingPlan === null ? sellingPlan = 0 : sellingPlan = parseInt(sellingPlan.value); 
      nbProductsSelected += quantity; 
      if (isNumeric(quantity) && quantity > 0 && nbProductsSelected <= 100) addVariantToQueue(id, quantity, sellingPlan, properties);
      reinitQuantitySelector(itemProduct); // Resets the quantity selector to its starting value
    });
  });    
  
  Shopify.moveAlong(addToCartButton);
}

// Adds variants as properties of a bundle to the cart
function addBundleVariantsToCart(addToCartButton, productLists) {    
  if (selectionComplete()) {
    Shopify.queue = [];   
    
    var productForm = addToCartButton.closest('.product__form');

    if (productForm === null) productForm = addToCartButton.closest('.section__page').querySelector('.product__form');
    
    var id = parseInt(productForm.querySelector('.product__variants').querySelector('input[name="id"]').value),
        quantity = 1,
        sellingPlan = productForm.querySelector('input[name="selling_plan"]'),
        properties = new Object();

    sellingPlan === null ? sellingPlan = 0 : sellingPlan = parseInt(sellingPlan.value);

    // We save the bundle name for the subscription app (Smartrr)
    if (sellingPlan != 0) {
      var bundle = SmartrrBundleInformation;

      if (typeof bundle !== 'undefined') {
        var bundleInfo = {
            items: [],
            date: new Date().getTime(),
            page: window.location.toString(),
            bundle: {
              name: bundle.name,
              slug: bundle.slug
            }
          };
        
        properties["Bundle"] = bundle.name;
      }
    }
    
    productLists.forEach((productList) => {
      var itemsProduct = productList.querySelectorAll('.item-product');
      
      itemsProduct.forEach((itemProduct) => {
        var id = itemProduct.dataset.variantId,
            sku = itemProduct.dataset.variantSku,
            itemQuantity = itemProduct.querySelector('.product__quantity-value');
        
        itemQuantity === null ? itemQuantity = 1 : itemQuantity = parseInt(itemQuantity.textContent);
        if (isNaN(itemQuantity)) itemQuantity = itemQuantity.value        
        if (isNumeric(itemQuantity) && itemQuantity > 0) {
          properties[sku] = itemQuantity;

          // We save the contents of the bundle for the subscription app (Smartrr)
          if (typeof bundleInfo !== 'undefined') {
            bundleInfo.items.push({
              id: id,
              quantity: itemQuantity,
              selling_plan: sellingPlan,
            });
          }
        }        
        reinitQuantitySelector(itemProduct); // Resets the quantity selector to its starting value
      });
    });

    // We save the bundle name for the subscription app (Smartrr)
    if (typeof bundleInfo !== 'undefined') properties["_smartrr_info"] = JSON.stringify(bundleInfo);
    addVariantToQueue(id, quantity, sellingPlan, properties);
    Shopify.moveAlong(addToCartButton);
  } else {
    showErrorsMessage(addToCartButton);
  }
}

// Adds a bundle from the bundle builder to the cart
function addBundleBuilderToCart(addToCartButton) {
  if (selectionComplete()) {
    var timestamp = Date.now(); // A timestamp is saved to associate an add to cart with a customisation session

    Shopify.queue = [];
    addAddonsToQueue(timestamp);
    addBundleToQueue(timestamp);
    Shopify.moveAlong(addToCartButton);
  } else {
    showErrorsMessage(addToCartButton);
  }
}

// Adds a variant to the cart
function addVariantToCart(addToCartButton, id, quantity, sellingPlan, properties) {
  Shopify.queue = [];  
  addVariantToQueue(id, quantity, sellingPlan, properties);  
  Shopify.moveAlong(addToCartButton);
}

// Adds a bundle variant to the cart
function addBundleVariantToCart(addToCartButton, id, quantity, sellingPlan, properties, itemProduct) {
  Shopify.queue = [];
  
  // We add the properties linked to the selected default products
  var defaultProducts = itemProduct.dataset.defaultProductsSku,
      defaultProductsSplit = defaultProducts.split(',');
  
  if (defaultProducts != '') {
    for (var i = 0; i < defaultProductsSplit.length; i++) {
      var defaultProduct = defaultProductsSplit[i],
          defaultProductSplit = defaultProduct.split('-'),
          productSku = defaultProductSplit[0],
          productQuantity = parseInt(defaultProductSplit[1]);

      properties[productSku] = productQuantity;
    }
  }
      
  addVariantToQueue(id, quantity, sellingPlan, properties);  
  Shopify.moveAlong(addToCartButton);
}

// Adds the bundle to the cart // TO CHECK FOR BUNDLES
function addBundleToQueue(timestamp) {
  var sectionPageBundleProducts = document.querySelector('.section__page[data-page-handle="bundle-products"]'),
      itemVariant = sectionPageBundleProducts.querySelector('.item-variant.selected'),
      step = parseInt(itemVariant.dataset.step),
      itemsProgression = document.querySelector('.selector-step-progression-wrapper').querySelectorAll('.step-progression-item.selected');
  
  if (itemVariant !== null) {
    var id = itemVariant.dataset.variantId,
        quantity = 1,
        sellingPlan = 0,
        properties = new Object();
    
    properties['#id'] = timestamp;

    // We add the properties linked to the selected products
    itemsProgression.forEach((element) => {
      var sku = element.dataset.variantSku;

      // If this product is not already in the properties, we just add the value "step".
      // Otherwise, we increase its quantity by the chosen amount of this product
      properties[sku] == null ? properties[sku] = step : properties[sku] = properties[sku] + step;     
    });
      
    addVariantToQueue(id, quantity, sellingPlan, properties);
  }
}

// Adds the selector addons to the cart // TO CHECK FOR BUNDLES
function addAddonsToQueue(timestamp) {
  var sectionPageAddons = document.querySelector('.section__page[data-page-handle="addons"]'),
      itemsProduct = sectionPageAddons.querySelectorAll('.item-product'),
      nbProductsSelected = 0,
      sellingPlan = 0;
  
  itemsProduct.forEach((itemProduct) => {
    var id = itemProduct.dataset.variantId,
        quantity = itemProduct.querySelector('.product__quantity-value'),
        sellingPlan = itemProduct.querySelector('input[name="selling_plan"]'),
        properties = new Object();

    quantity === null ? quantity = 0 : quantity = parseInt(quantity.textContent);
    if (isNaN(quantity)) quantity = quantity.value
    sellingPlan === null ? sellingPlan = 0 : sellingPlan = parseInt(sellingPlan.value); 
    nbProductsSelected += quantity; 
    if (isNumeric(quantity) && quantity > 0 && nbProductsSelected <= 99) addVariantToQueue(id, quantity, sellingPlan, properties);
    reinitQuantitySelector(itemProduct); // Resets the quantity selector to its starting value
  });
}

// Adds a variant to the queue
function addVariantToQueue(id, quantity, sellingPlan, properties) {    
  Shopify.queue.push({
    variantId: id,
    quantity: quantity,
    selling_plan: sellingPlan,
    properties: properties
  });
}

// Pushes the queue to the cart
Shopify.moveAlong = function(addToCartButton) {
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift(),
        data = {};

    if (request.selling_plan != 0 && request.properties) {
      data = {
        id: request.variantId,
        quantity: request.quantity,
        selling_plan: request.selling_plan,
        properties: request.properties
      };
    } else if (request.selling_plan != 0) {
      data = {
        id: request.variantId,
        quantity: request.quantity,
        selling_plan: request.selling_plan
      };
    } else if (request.properties) {
      data = {
        id: request.variantId,
        quantity: request.quantity,
        properties: request.properties
      };
    }

    const body = JSON.stringify(data);
    fetch(`${routes.cartAddUrl}.js`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        Shopify.queue.length ? Shopify.moveAlong(addToCartButton) : handleAddToCartResult(addToCartButton, response);
      })
      .catch((error) => {
        handleAddToCartError(addToCartButton, error);
        if (Shopify.queue.length) Shopify.moveAlong(addToCartButton);
      });
  } else {
    handleAddToCartResult(addToCartButton, '');
  }
};

// Chooses what actions to take after an add to cart
function handleAddToCartResult(addToCartButton, result) {
  document.dispatchEvent(new Event('product.added')); // An general event is broadcast to perform additional processing
  
  if (addToCartButton !== null) {
    var redirectAction = addToCartButton.getAttribute('data-redirect-action'),
        redirectUrl = addToCartButton.getAttribute('data-redirect-url');

    if (addToCartButton.dataset.action != 'add-to-cart-products-list' && addToCartButton.getAttribute('data-disabled') == 'false') addToCartButton.removeAttribute('disabled');

    if (redirectAction == 'message') {
      addToCartButton.querySelector('span.button-text').innerHTML = window.languages.addedToCartButton;

      // The original message of the button is restored after 2 seconds
      setTimeout(() => {
        addToCartButton.querySelector('span.button-text').innerHTML = addToCartButton.dataset.buttonText;
        if (addToCartButton.querySelector('span.button-price') !== null) addToCartButton.querySelector('span.button-price').classList.remove('hidden');
      }, 2000);
      
      document.dispatchEvent(new Event('product.added.message')); // An event is broadcast so that the side cart can perform additional processing, such as redisplaying the side cart
    } else if (redirectAction == 'drawer') {
      addToCartButton.querySelector('span.button-text').innerHTML = addToCartButton.dataset.buttonText;
      if (addToCartButton.querySelector('span.button-price') !== null) addToCartButton.querySelector('span.button-price').classList.remove('hidden');      
      if (isInModal(addToCartButton)) hideModal(addToCartButton.closest('.modal')); // We close the quick shop if a popup is opened      
      document.dispatchEvent(new Event('product.added.drawer')); // An event is broadcast so that the side cart can perform additional processing, such as redisplaying the side cart
    } else if (redirectAction == 'page') {
      addToCartButton.querySelector('span.button-text').innerHTML = addToCartButton.dataset.buttonText;
      window.location.href = redirectUrl;
    } else if (redirectAction == 'checkout') {
      addToCartButton.querySelector('span.button-text').innerHTML = addToCartButton.dataset.buttonText;
      window.location.href = '/checkout';
    } else {

    }
  } else {
    !isPage('/cart') ? document.dispatchEvent(new Event('product.added.message')) : window.location.reload();
  }
}

// Manages the actions to be taken if there is an error after an add to cart
function handleAddToCartError(addToCartButton, error) {
  var errorMessage = error.message;

  console.log(errorMessage);
  alert(errorMessage);
  
  if (addToCartButton !== null) {
    // The original message of the button is restored after 2 seconds
    setTimeout(() => {
      addToCartButton.querySelector('span.button-text').textContent = addToCartButton.dataset.buttonText;
      addToCartButton.removeAttribute('disabled');
    }, 2000);
  }
}

// Resets the quantity selector
function reinitQuantitySelector(element) {
  var quantityWrapper = element.querySelector('.product__quantity-wrapper');

  if (quantityWrapper !== null) {
    var quantitySub = quantityWrapper.querySelector('.button--quantity-sub'),
        quantityAdd = quantityWrapper.querySelector('.button--quantity-add'),
        quantity = quantityWrapper.querySelector('.product__quantity-value'),
        quantityMin = parseInt(quantityWrapper.dataset.min),
        quantityInitialValue = parseInt(quantityWrapper.dataset.initialValue);
      
    quantity.textContent = quantityInitialValue;
    quantity.value = quantityInitialValue;
  
    if (quantitySub !== null && quantityInitialValue <= quantityMin) quantitySub.setAttribute('disabled', 'disabled');
    if (quantityAdd !== null) quantityAdd.removeAttribute('disabled');
  }
}

// Resets the selection made (DEPRECATED)
function reinitSelection() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      selectorStepProgressions = document.querySelectorAll('.selector-step-progression'), 
      selectorSummaries = document.querySelectorAll('.selector-summary'),
      nbItemsSelectedTexts = document.querySelectorAll('.nb-items-selected');

  // Selector step progressions
  selectorStepProgressions.forEach((element) => {
    element.querySelectorAll('.step-progression-item').forEach((slot) => {
      // Removes the colour and attributes of a progress item
      slot.classList.remove('selected');
      slot.style.background = element.dataset.colorBg;
      slot.removeAttribute('data-product-handle');
      slot.removeAttribute('data-variant-id');
      slot.removeAttribute('data-variant-sku');
      slot.removeAttribute('data-product-title');
    });
    
    // Updates the number of selected items
    element.setAttribute('data-nb-items-selected', 0);
  });

  // Selector summaries
  selectorSummaries.forEach((element) => {
    element.querySelectorAll('.summary-item').forEach((summaryItem) => {
      summaryItem.remove();
    });
    element.closest('.block').setAttribute('data-hide-on-load', true);

    // Updates the number of selected items
    element.setAttribute('data-nb-items-selected', 0);
  });   

  // Nb items selected
  nbItemsSelectedTexts.forEach((element) => {
    element.textContent = '0';
    element.closest('.block').setAttribute('data-hide-on-load', true);
  });
}

/**
 * ----------------------------------------------------------------------------------------------------
 * TEMPLATES
 * ----------------------------------------------------------------------------------------------------
 */

/**
 * TEMPLATE - PRODUCT
 */

setupEventListenersForQuickShop();

// Creates the event listeners
function setupEventListenersForQuickShop() {
  // On clicking on a link to display a product page in quick shop mode
  document.querySelectorAll('[data-action="open-quick-shop"]').forEach((element) => {
    element.addEventListener('click', openQuickShop);
  });
  
  // On clicking on a link to change the product page in quick shop mode
  document.querySelectorAll('[data-action="toggle-quick-shop"]').forEach((element) => {
    element.addEventListener('click', toggleQuickShop);
  });
}

// Opens a product page in quick shop mode
function openQuickShop(url) {
  var quickShopModal = document.querySelector('.modal--quick-shop'),
      target = null,
      quickShopUrl = url,
      linkColor = 'var(--text-color)';
  
  if (url.currentTarget !== undefined) {
    target = event.currentTarget,        
    quickShopUrl = target.getAttribute('data-quick-shop-url'),
    linkColor = target.ownerDocument.defaultView.getComputedStyle(target, null).color;

    if (!quickShopUrl) quickShopUrl = target.parentNode.getAttribute('data-quick-shop-url');
    if (target.classList.contains('item__image-link')) linkColor = 'var(--text-color)';

    event.preventDefault();  
  }
  
  showModal(quickShopModal);
  
  fetch(quickShopUrl)
    .then((response) => response.text())
    .then((text) => {
      quickShopModal.querySelector('.modal__body--inner').innerHTML = text;
      quickShopModal.querySelector('.button--cross').style.color = linkColor;
  
      // On load
      setupInlineScripts(quickShopModal);
      setupEventListenersAfterFetchingQuickShop();
      startCarousels(true);
      startProductCompareBars('all', true);
      loadProductRecommendations();
    });
}

// Creates the event listeners needed after fetch
function setupEventListenersAfterFetchingQuickShop() {
  if (typeof setupEventListenersForProductForm === 'function') setupEventListenersForProductForm();
  if (typeof setupEventListenersForProductsItems === 'function') setupEventListenersForProductsItems();
  if (typeof setupEventListenersForProductMediaCarousel === 'function') setupEventListenersForProductMediaCarousel();
  if (typeof setupEventListenersForProductsCompareCarousel === 'function') setupEventListenersForProductsCompareCarousel();
  if (typeof setupEventListenersForLoopTextsImages === 'function') setupEventListenersForLoopTextsImages();
  
  setupEventListenersForShowMoreAnimation();
  setupEventListenersForCollapsible();
  setupEventListenersForTabs();
  setupEventListenersForDropdownsSelects();
  setupEventListenersForModals();
  setupEventListenersForHiddenBlocks();
  setupEventListenersForVideos();
}

// Closes a product page in quick shop mode and opens another one
function toggleQuickShop(url) {
  event.preventDefault();
  closeModal();
  
  setTimeout(() => {
    openQuickShop(url);
  }, 1000);
}

// Adds the small spinner to the quick shop popup
function closeQuickShop() {
  var quickShopModal = document.querySelector('.modal--quick-shop');

  event.preventDefault();  
  quickShopModal.querySelector('.modal__body--inner').innerHTML = '<div class="quick-shop__spinner spinner-container spinner-container--large"><div class="spinner spinner--circle"></div></div>';
}

/**
 * ----------------------------------------------------------------------------------------------------
 * SECTIONS
 * ----------------------------------------------------------------------------------------------------
 */

/**
 * SECTIONS - GENERAL
 */

setupEventListenersForSections();

// Creates the event listeners
function setupEventListenersForSections() {
  // On clicking on a close button in a section
  document.querySelectorAll('[data-action="close-bar"]').forEach((element) => {
    element.addEventListener('click', hideBarSection);
  });
}

// Hides the bar section
function hideBarSection() {
  event.currentTarget.closest('.shopify-section').classList.add('hidden');
}

/**
 * SECTION - SELECTOR / BUNDLE BUILDER
 */

setupEventListenersForBundleBuilder();

// Creates the event listeners
function setupEventListenersForBundleBuilder() {
  // On clicking the button to return to the previous step of the selector
  document.querySelectorAll('[data-action="selector-previous-step"]').forEach((element) => {
    element.addEventListener('click', displaySelectorPreviousStep);
  });
  
  // On clicking the button to go to the next step of the selector
  document.querySelectorAll('[data-action="selector-next-step"]').forEach((element) => {
    element.addEventListener('click', displaySelectorNextStep);
  });
  
  // On clicking the button to go to the next step of the selector (single cta)
  document.querySelectorAll('[data-action="selector-next-step-add-to-cart"]').forEach((element) => {
    element.addEventListener('click', chooseSelectorCtaAction);
  });
  
  // On clicking on a selector step button
  document.querySelectorAll('[data-action="selector-goto-step"]').forEach((element) => {
    element.addEventListener('click', displaySelectorStep);
  });

  // On clicking on the button to filter the type of product
  document.querySelectorAll('[data-action^="filter-products_"]').forEach((element) => {
    element.addEventListener('click', filterSelectorProducts);
  });
}

// Displays the previous step of the selector // TO CHECK FOR BUNDLES
function displaySelectorPreviousStep() {
  var carousels = document.querySelectorAll('.custom-section.carousel-wrapper'),
      carousel = document.querySelector('.custom-section.carousel--bundle-builder'),
      currentSlide = carousel.querySelector('.swiper-slide-active'),
      currentSlideIndex = parseInt(currentSlide.dataset.slideIndex);

  if (currentSlideIndex > 0) {
    event.preventDefault();
    scrollToTop();
    carousels.forEach((element) => {
      if (isSliderInitialized(element.closest('.carousel'))) element.closest('.carousel').swiper.slidePrev(parseInt(element.dataset.speed), false);
    });
    handleSelectorPreviousStepElements();
  }
}

// Displays the next step of the selector // TO CHECK FOR BUNDLES
function displaySelectorNextStep() {
  var target = event.currentTarget,
      carousels = document.querySelectorAll('.custom-section.carousel-wrapper'),
      carousel = document.querySelector('.custom-section.carousel--bundle-builder'),
      stepCompleted = true,
      alertText = window.theme.alertSelector;
  
  event.preventDefault();
  scrollToTop();
  
  // TODO (depending on the logic of the store)
  // Check if every step of the selection is completed
  
  // Checks if all step one products have been selected
  if (isCurrentStep('bundle-products') && !selectorStepOneComplete()) {
    stepCompleted = false;
    alertText = window.languages.alertSelectorStepOne;
  }
  
  if (stepCompleted) {
    carousels.forEach((element) => {
      if (isSliderInitialized(element.closest('.carousel'))) element.closest('.carousel').swiper.slideNext(parseInt(element.dataset.speed), false);
    });
    handleSelectorNextStepElements();
  } else {
    target.setAttribute('disabled', 'disabled');
    target.querySelector('.button-text').textContent = target.dataset.buttonText;
    alert(alertText);
  }
}

// Selects the action to be taken when moving to the next step in the selector // TO CHECK FOR BUNDLES
function chooseSelectorCtaAction() {
  var carousel = document.querySelector('.custom-section.carousel--bundle-builder');
  
  if (!isLastStep(carousel)) {
    displaySelectorNextStep();
  } else {    
    event.preventDefault();
    addToCartFromBundleBuilder();
  }
}

// Displays the clicked step of the selector // TO CHECK FOR BUNDLES
function displaySelectorStep() {
  var target = event.currentTarget,
      carousels = document.querySelectorAll('.custom-section.carousel-wrapper'),
      carousel = document.querySelector('.custom-section.carousel--bundle-builder'),
      selectorStep = target.closest('.selector-step'),
      currentIndex = parseInt(carousel.querySelector('.swiper-slide-active').dataset.slideIndex),
      newIndex = parseInt(selectorStep.dataset.stepIndex);
  
  event.preventDefault();
  scrollToTop();
  carousels.forEach((element) => {
    if (isSliderInitialized(element.closest('.carousel'))) element.closest('.carousel').swiper.slideTo(newIndex, parseInt(element.dataset.speed), false);
  });

  if (newIndex != currentIndex) {
    currentIndex > newIndex ? handleSelectorPreviousStepElements() : handleSelectorNextStepElements();
  }
}

// Manages the display of certain elements when moving to the previous step of the selector // TO CHECK FOR BUNDLES
function handleSelectorPreviousStepElements() {
  // TODO (depending on the logic of the store)
  var carousel = document.querySelector('.carousel--bundle-builder').closest('.carousel');

  // Handles the overflow of the slider that has been removed by the sticky column
  if (isCurrentStep('bundle-products')) carousel.classList.remove('no-overflow');
}

// Manages the display of certain elements when moving to the next step of the selector // TO CHECK FOR BUNDLES
function handleSelectorNextStepElements() {
  // TODO (depending on the logic of the store)
  var carousel = document.querySelector('.carousel--bundle-builder').closest('.carousel');

  // Handles the overflow of the slider that has been removed by the sticky column
  if (!isCurrentStep('bundle-products')) carousel.classList.add('no-overflow');
}

// Checks if the step passed in parameter is the current step
function isCurrentStep(stepName) {
  var sectionPage = document.querySelector('.section__page[data-page-handle="' + stepName + '"]');

  return sectionPage !== null && sectionPage.classList.contains('swiper-slide-active') ? true : false;
}

// Checks if the current step is the last step of the selector
function isLastStep(selector) {
  var steps = selector.querySelectorAll('.section__page.custom-section'),
      lastStep = steps[steps.length - 1];
  
  return lastStep.classList.contains('swiper-slide-active') ? true : false;
}

// Filters products to display
function filterSelectorProducts() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      action = target.dataset.action,
      tag = action.split('_').pop(),
      product = sectionPage.querySelector('.item-product[data-item-template-suffix="' + tag + '"]');

  if (product === null) product = sectionPage.querySelector('.item-product[data-product-tags*="' + tag + '"]');

  event.preventDefault();
  //scrollToTop();
  target.closest('.buttons-wrapper').querySelector('.active').classList.remove('active');
  target.closest('.button-wrapper').classList.add('active');

  if (tag == 'all') {
    sectionPage.querySelectorAll('.block__grid-products-2').forEach((element) => {
      var previousSibling = element.closest('.shopify-block').previousElementSibling,
          blockTitle = previousSibling.querySelector('.block.block__title');
      
      element.style.display = 'block';
      if (blockTitle !== null) blockTitle.style.display = 'block';
    });
  } else {
    sectionPage.querySelectorAll('.block__grid-products-2').forEach((element) => {
      var previousSibling = element.closest('.shopify-block').previousElementSibling,
          blockTitle = previousSibling.querySelector('.block.block__title');
      
      element.style.display = 'none';
      if (blockTitle !== null) blockTitle.style.display = 'none';
    });
    var previousSibling = product.closest('.shopify-block').previousElementSibling,
        blockTitle = previousSibling.querySelector('.block.block__title');
    
    product.closest('.block__grid-products-2').style.display = 'block';
    if (blockTitle !== null) blockTitle.style.display = 'block';
  }
}

/**
 * ----------------------------------------------------------------------------------------------------
 * BLOCKS
 * ----------------------------------------------------------------------------------------------------
 */

/**
 * BLOCKS - GENERAL
 */

setupEventListenersForCategories();

// Creates the event listeners
function setupEventListenersForCategories() {
  // On clicking on a category in the custom section
  document.querySelectorAll('[data-action="toggle-category"]').forEach((element) => {
    element.addEventListener('click', toggleCategory);
  });

  // On clicking on a category in the custom section
  document.querySelectorAll('[data-action="show-category"]').forEach((element) => {
    element.addEventListener('click', showCategory);
  });

  // On clicking on a rewind category link in the custom section
  document.querySelectorAll('[data-action="hide-category"], [href="#hide-category"]').forEach((element) => {
    element.addEventListener('click', hideCategory);
  });
}

// Displays the selected category with the selected category title visible
function toggleCategory() {
  var target = event.currentTarget,
      sectionCategories = target.closest('.section-categories'),
      categoriesTitles = sectionCategories.querySelector('.categories-titles'),
      categoriesContents = sectionCategories.querySelector('.categories-contents'),
      categoryNumber = target.dataset.categoryNumber;
  
  if (!target.classList.contains('selected')) { 
    selectCategoryTitle(categoriesTitles, target);
    showCategoryContent(categoriesContents, categoryNumber);
  }
}

// Displays the selected category with the selected category title hidden
function showCategory() {
  var target = event.currentTarget,
      sectionCategories = target.closest('.section-categories'),
      categoriesTitles = sectionCategories.querySelector('.categories-titles'),
      categoriesContents = sectionCategories.querySelector('.categories-contents'),
      categoryNumber = target.dataset.categoryNumber;
  
  if (!target.classList.contains('selected')) { 
    selectCategoryTitle(categoriesTitles, target);
    hideCategoriesTitles(categoriesTitles);
    showCategoryContent(categoriesContents, categoryNumber);
  }
}

// Hides the selected category and shows the categories title
function hideCategory() {
  var target = event.currentTarget,
      sectionCategories = target.closest('.section-categories'),
      categoriesTitles = sectionCategories.querySelector('.categories-titles'),
      categoriesContents = sectionCategories.querySelector('.categories-contents');

  event.preventDefault();
  hideCategoryContent(categoriesContents);
  showCategoriesTitles(categoriesTitles);
  unselectCategoryTitle(categoriesTitles);
}

// Selects a category title and changes its style
function selectCategoryTitle(categoriesTitles, target) {
  categoriesTitles.querySelectorAll('.category-title.selected').forEach((element) => {
    element.setAttribute('aria-selected', false);
    element.classList.remove('selected');
  });
  target.setAttribute('aria-selected', true);
  target.classList.add('selected');
}

// Unselects a category title and changes its style
function unselectCategoryTitle(categoriesTitles) {
  categoriesTitles.querySelectorAll('.category-title.selected').forEach((element) => {
    element.setAttribute('aria-selected', false);
    element.classList.remove('selected');
  });
}

// Shows the categories titles
function showCategoriesTitles(categoriesTitles) {
  categoriesTitles.classList.remove('hidden');
}

// Hides the categories titles
function hideCategoriesTitles(categoriesTitles) {
  categoriesTitles.classList.add('hidden');
}

// Displays the category content
function showCategoryContent(categoriesContents, categoryNumber) {
  categoriesContents.querySelectorAll('.category-contents:not(.hidden)').forEach((element) => {
    element.classList.add('hidden');
  });
  
  categoriesContents.querySelector('.category-contents[data-category-number="' + categoryNumber + '"]').classList.remove('hidden');
}

// Hides the category content
function hideCategoryContent(categoriesContents) {
  categoriesContents.querySelectorAll('.category-contents:not(.hidden)').forEach((element) => {
    element.classList.add('hidden');
  });
}

setupEventListenersForHiddenBlocks();

// Creates the event listeners
function setupEventListenersForHiddenBlocks() {
  // On clicking on a button to display the hidden blocks on load
  document.querySelectorAll('[data-action="show-hidden-blocks"]').forEach((element) => {
    element.addEventListener('click', showHiddenBlocks);
  });
  
  // On clicking on a button to hide the hidden blocks on load
  document.querySelectorAll('[data-action="hide-hidden-blocks"]').forEach((element) => {
    element.addEventListener('click', hideHiddenBlocks);
  });
  
  // On clicking on a button to display the hidden blocks on load (without hiding the others)
  document.querySelectorAll('[data-action="toggle-hidden-blocks"]').forEach((element) => {
    element.addEventListener('click', toggleHiddenBlocks);
  });
  
  // On clicking on a button to display the hidden text in a paragraph
  document.querySelectorAll('[data-action="show-full-text"]').forEach((element) => {
    element.addEventListener('click', showFullText);
  });
}

// Displays the hidden blocks
function showHiddenBlocks() {
  var target = event.currentTarget,
      sectionColumn = target.closest('.section-column'),
      blocksToHide = sectionColumn.querySelectorAll('.block[data-hide-on-load="false"], .block:not([data-hide-on-load="true"])'),
      blockToShow = sectionColumn.querySelectorAll('.block[data-hide-on-load="true"]');
  
  event.preventDefault();  
  blocksToHide.forEach((element) => {
    element.style.display = 'none';
  });  
  blockToShow.forEach((element) => {
    element.style.display = 'block';
  });
}

// Hides the hidden blocks
function hideHiddenBlocks() {
  var target = event.currentTarget,
      sectionColumn = target.closest('.section-column'),
      blocksToHide = sectionColumn.querySelectorAll('.block[data-hide-on-load="true"]'),
      blockToShow = sectionColumn.querySelectorAll('.block[data-hide-on-load="false"], .block:not([data-hide-on-load="true"])');
  
  event.preventDefault();  
  blocksToHide.forEach((element) => {
    element.style.display = 'none';
  });  
  blockToShow.forEach((element) => {
    element.style.display = 'block';
  });
}

// Displays the hidden blocks (without hiding the others)
function toggleHiddenBlocks() {
  var target = event.currentTarget,
      sectionColumn = target.closest('.section-column'),
      blocksToToggle = sectionColumn.querySelectorAll('.block[data-hide-on-load="true"]'),
      buttonTextTag = target.querySelector('.button-text'),
      buttonText = target.dataset.buttonText,
      buttonTextToggle = target.dataset.buttonTextToggle,
      currentButtonText = buttonTextTag.textContent;
  
  event.preventDefault();  
  blocksToToggle.forEach((element) => {
    toggle(element, 'block');
  });

  // Changes the text of the button
  currentButtonText == buttonText ? buttonTextTag.textContent = buttonTextToggle : buttonTextTag.textContent = buttonText;
}

// Displays the full text of a paragraph
function showFullText() {
  var target = event.currentTarget,
      content = target.closest('.block__button').parentNode.querySelector('.block__content'),
      buttonTextTag = target.querySelector('.button-text'),
      buttonText = target.dataset.buttonText,
      buttonTextToggle = target.dataset.buttonTextToggle,
      currentButtonText = buttonTextTag.textContent;

  event.preventDefault();
  if (content !== null) content.classList.toggle('text-overflow');

  // Changes the text of the button
  currentButtonText == buttonText ? buttonTextTag.textContent = buttonTextToggle : buttonTextTag.textContent = buttonText;
}

/**
 * BLOCK - CAROUSELS
 */

// Creates the event listeners
function setupEventListenersForCarousels() {
  if (typeof setupEventListenersForProductsCompareCarousel === 'function') setupEventListenersForProductsCompareCarousel();
}
 
/**
 * BLOCK - VIDEO
 */

setupEventListenersForVideos();

// Creates the event listeners
function setupEventListenersForVideos() {
  // On clicking on a native video
  document.querySelectorAll('.video-file').forEach((element) => {
    element.addEventListener('click', handleVideo);
  });
}

// When exiting full screen mode on a video
document.addEventListener('fullscreenchange', exitFullScreen);
document.addEventListener('webkitfullscreenchange', exitFullScreen);
document.addEventListener('mozfullscreenchange', exitFullScreen);
document.addEventListener('webkitendfullscreen', exitFullScreen);

// Starts or stops / Mutes or unmutes / Enlarges or shrinks a video
function handleVideo() {
  var target = event.currentTarget,
      videoWrapper = target.closest('.video-wrapper'),
      video = videoWrapper.querySelector('video'),
      videoButton = videoWrapper.querySelector('button'),
      playClick = video.getAttribute('data-play-click'),
      unmuteClick = video.getAttribute('data-unmute-click'),
      enlargeClick = video.getAttribute('data-enlarge-click');
  
  if (playClick == 'true') playVideo(video, videoButton, unmuteClick, enlargeClick);  
  if (unmuteClick == 'true') unmuteVideo(videoWrapper, video, enlargeClick);  
  if (enlargeClick == 'true') enlargeVideo(videoWrapper, video);
}

// Starts or stops a video
function playVideo(video, videoButton, unmuteClick, enlargeClick) {    
  if (video.paused) {
    video.play();
    videoButton.classList.remove('active');
  } else {
    if (unmuteClick == 'false' && enlargeClick == 'false') {
      video.pause();
      videoButton.classList.add('active');
    }
  }
}

// Mutes or unmutes a video
function unmuteVideo(videoWrapper, video, enlargeClick) {
  var blockInner = videoWrapper.closest('.block--inner');
  
  if (video.muted) {
    video.muted = false;
  } else {
    if (enlargeClick == 'false') {
      video.muted = true;
    } else if (blockInner.classList.contains('larger')) {
      video.muted = true;
    }
  }
}

// Enlarges or shrinks a video
function enlargeVideo(videoWrapper, video) {  
  var blockInner = videoWrapper.closest('.block--inner');
  
  if (!blockInner.classList.contains('larger')) {
    blockInner.classList.add('larger');

    if (window.innerWidth < 650) {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) { 
        video.msRequestFullscreen();
      } else {
        video.webkitEnterFullscreen();
      }
    }
  } else {
    blockInner.classList.remove('larger');
  }
} 

// Exits full screen mode on a video
function exitFullScreen() { 
  if (!document.fullscreen) {
    document.querySelectorAll('video').forEach((element) => {
      element.closest('.block--inner').classList.remove('larger');
      element.muted = true;
    });
  }
}

/**
 * ----------------------------------------------------------------------------------------------------
 * APPS
 * ----------------------------------------------------------------------------------------------------
 */

/**
 * APP - KLAVIYO
 */

setupEventListenersForKlaviyo();

// Creates the event listeners
function setupEventListenersForKlaviyo() {
  // On clicking on a link that displays a popup from Klaviyo
  document.querySelectorAll('[href="#open_klaviyo_popup"]').forEach((element) => {
    element.addEventListener('click', openKlaviyoPopup);
  });
}

// Opens a Klaviyo popup
function openKlaviyoPopup() {
  var target = event.currentTarget,
      klOnSite = window._klOnsite || [],
      formId = target.dataset.form;

  event.preventDefault();
  klOnSite.push(['openForm', formId]);
}